"use strict";
// tslint:disable:object-literal-sort-keys
// tslint:disable:no-shadowed-variable
/**
 * @file Manages navigation between forms and provides higher level management of and information about the application.
 * @copyright 2016 Microsoft Corporation
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Shell_ProcessingMessage: "Please wait. We're processing your request.",
            Shell_LeavingSession: "You might lose data that you haven't saved yet, and you might have to restart AX.",
            Shell_LeavingDebugIE: "For improved performance, it is recommended that this Internet Explorer instance be left open and debugging stopped from within Visual Studio. This is so future debug sessions will be able to re-use this instance of Internet Explorer.",
            Shell_BrowserTitleFormat: "{0} -- {1}",
            Shell_LoadingTitle: "Loading",
            Shell_AbortedNavigation: "The navigation request was canceled due to unfinished work on this form.",
            Shell_AbortedNavigationPopout: "Please fix all validation errors in open forms before navigating.",
            Shell_ClosedForm: "The page has been closed.",
            Shell_MultipleNotifications: "You have new messages.",
            Shell_HideNotificationPopup: "Close",
            Shell_PopupBlocked: "The window could not be opened. Please check your pop-up blocker settings and add an exception for Microsoft Dynamics 365 {0} ",
            Shell_D365ShortTitle: "Dynamics 365",
            Shell_OfficeWaffleTitle: "Office 365",
            Shell_OpenMessageCenter: "Open message center",
            Shell_OpenCompanyPicker: "Open company picker",
            Shell_MainFormContainer: "Go to main form container",
            Shell_GoHome: "Go to the dashboard",
            Shell_OpenTraceParser: "Open the trace parser",
            Shell_GoToNavBar: "Go to the navigation bar",
            Shell_OpenNavPane: "Open navigation pane",
            Shell_GoToNavPane: "Go to the navigation pane",
            Shell_CloseNavPane: "Close the navigation pane",
            Shell_OpenTaskRecorder: "Open the Task recorder pane",
            Shell_MoveFocusToTaskRecorder: "Move focus to the Task recorder pane",
            Shell_Splitter: "Splitter",
        },
    });
    var controls;
    (function (controls) {
        /** @obsolete */
        var Shell = /** @class */ (function (_super) {
            __extends(Shell, _super);
            function Shell() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Shell;
        }($dyn.ui.Control));
        controls.Shell = Shell;
    })(controls = $dyn.controls || ($dyn.controls = {}));
    // TODO unused control type?
    $dyn.adapter({ id: "NavBar", controlType: "Shell", template: "NavBar" });
    $dyn.adapter({ id: "MessageCenterEmbedded", controlType: "Shell", template: "MessageCenterEmbedded" });
    /**
     * Viewport constants that are based on the display density.
     * @private
     */
    var _viewportSizesPreDensity = {
        "21": { viewportWidth: 245, gutterWidth: 33 },
        "30": { viewportWidth: 320, gutterWidth: 48 },
    };
    var bindingHandlers;
    (function (bindingHandlers) {
        /**
         * Register a callback to allow a control to change behavior or display style when the form viewport size changes.
         * @internal
         */
        bindingHandlers.FormViewportSize = function () {
            var callBack;
            return {
                /**
                 * Registers a callback function.
                 * @param options Callback function that should be executed when the form viewport size changes.
                 * @param dataContext this context to bind on the callback function.
                 */
                apply: function (options, dataContext) {
                    if (!callBack) {
                        callBack = options.bind(dataContext);
                        $(document.body).on($dyn.shell.formViewportSizeEvent, callBack);
                    }
                },
                /**
                 * Unregisters the callback function.
                 */
                dispose: function () {
                    if (callBack) {
                        $(document.body).off($dyn.shell.formViewportSizeEvent, callBack);
                    }
                },
            };
        };
        /**
         * Registers a callback to allow a control to change behavior or display style when the shell viewport size changes.
         * @internal
         */
        bindingHandlers.ShellViewportSize = function () {
            var callBack;
            return {
                /**
                 * Registers a callback function.
                 * @param options Callback function that should be executed when the shell viewport size changes.
                 * @param dataContext this context to bind on the callback function.
                 */
                apply: function (options, dataContext) {
                    callBack = options;
                    $(document.body).on($dyn.shell.shellViewportSizeEvent, callBack.bind(dataContext));
                },
                /**
                 * Unregisters the callback function.
                 */
                dispose: function () {
                    if (callBack) {
                        $(document.body).off($dyn.shell.shellViewportSizeEvent, callBack);
                    }
                },
            };
        };
        /**
         * Registers a callback to allow a control to change behavior or display style when the shell viewport size changes.
         * @internal
         */
        bindingHandlers.ShellViewportWidthSize = function () {
            var callBack;
            return {
                /**
                 * Registers a callback function.
                 * @param options Callback function that should be executed when the shell viewport size changes.
                 * @param dataContext this context to bind on the callback function.
                 */
                apply: function (options, dataContext) {
                    callBack = options;
                    $(document.body).on($dyn.shell.shellViewportWidthSizeEvent, callBack.bind(dataContext));
                },
                /**
                 * Unregisters the callback function.
                 */
                dispose: function () {
                    if (callBack) {
                        $(document.body).off($dyn.shell.shellViewportWidthSizeEvent, callBack);
                    }
                },
            };
        };
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
    $(window).on("resize", function (evt) {
        if (!$dyn.shell.pendingResize) {
            window.setTimeout(function () {
                var runReflow = false;
                $dyn.shell.viewportSizeChanged();
                // if Height changed trip reflow
                var windowHeight = $(window).height();
                if ($dyn.shell._lastWindowHeight !== windowHeight) {
                    $dyn.shell._lastWindowHeight = windowHeight;
                    runReflow = true;
                }
                // if width changed trip reflow
                var windowWidth = $(window).width();
                if ($dyn.shell._lastWindowWidth !== windowWidth) {
                    $dyn.shell._lastWindowWidth = windowWidth;
                    runReflow = true;
                }
                if (runReflow) {
                    $dyn.layout.reflowRootForm();
                }
                // tslint:disable-next-line:forin
                for (var id in $dyn.shell.resizeHandlers) {
                    var funcOptions = $dyn.shell.resizeHandlers[id];
                    $dyn.applyFunction(funcOptions.func, funcOptions.thisArg);
                }
                $dyn.shell.pendingResize = false;
            }, 0);
        }
        $dyn.shell.pendingResize = true;
    });
    // Observable to help with scenarios where the user is not immediately available such as the nav bar.
    $dyn.user = $dyn.observable();
    $dyn.company = $dyn.observable();
    $dyn.activeForm = $dyn.observable();
    /**
     * Manages navigation between forms and provides higher level management of and information about the application.
     */
    var shell;
    (function (shell) {
        /** @private */
        shell._nextId = 1;
        /**
         * Contains all primary forms.
         * @internal
         * @description Push/pop from the end of the array.  Can set to null in the middle.
         * Note: If a form dialog (slider) is the first form opened, it will be considered a primary form by the shell.
         */
        shell.stack = $dyn.observableArray([]);
        shell._currentStackIndex = -1;
        /**
         * Contains all forms that are open in the aside pane.
         * Last in the array is top of the stack.
         * Being open does not require that they are currently visible.
         * @private
         */
        shell._asidePaneStack = $dyn.observableArray([]);
        /**
         * Contains all forms that are application modal dialogs (lightboxes).
         * Push/pop from the array.
         * @internal
         */
        shell.dialogStack = $dyn.observableArray([]);
        shell.showModulesFlyout = $dyn.observable(false);
        shell.clientInitialFormRequested = $dyn.observable(false);
        shell._timerHandle = -1;
        shell._shellBlockingCount = 0;
        shell._blockingTextAnimated = false;
        shell._blockingDivDescription = "";
        shell._blockingDivKeystrokeLossCount = 0;
        shell._navigationCompleteEvent = null;
        shell._shellReflowEvent = null;
        shell._navBar = null;
        shell._navigationPaneIsOpen = false;
        shell.isNavigationPanePinned = $dyn.observable(false);
        shell.isSmallViewPort = $dyn.observable(false);
        shell._extendedEventLoopCount = 0;
        shell._popstateLoopCount = 0;
        shell._popstateLoopCountResetId = null;
        shell._noNavigationPane = false;
        shell._NoServerProductName = "Finance and Operations";
        /**
         * If true, the normal application suite navigation is replaced by workspace links in the navigation bar.
         * @private
         */
        shell._isWorkspaceNavigationMode = $dyn.observable(false);
        /**
         * Tracks that form rendering is complete, i.e. form is shown to the user and layout is done.
         * @private
         */
        shell.formRenderingComplete = $dyn.observable(false);
        /**
         * Does the client have internet access available?
         */
        shell.hasRestrictedInternet = $dyn.observable(undefined);
        /**
         * Enums for Commands of command buttons.
         */
        var CalledCommandButtonFunction;
        (function (CalledCommandButtonFunction) {
            CalledCommandButtonFunction["New"] = "New";
            CalledCommandButtonFunction["DeleteRecord"] = "DeleteRecord";
        })(CalledCommandButtonFunction = shell.CalledCommandButtonFunction || (shell.CalledCommandButtonFunction = {}));
        /**
         * Query string keys used by the framework.  Keys are reserved for internal use.
         */
        var QueryStringKeys;
        (function (QueryStringKeys) {
            QueryStringKeys["sessionKey"] = "sid";
            QueryStringKeys["companyKey"] = "cmp";
            QueryStringKeys["partitionKey"] = "prt";
            QueryStringKeys["languageKey"] = "lng";
            QueryStringKeys["themeKey"] = "theme";
            QueryStringKeys["densityKey"] = "density";
            QueryStringKeys["fromVS"] = "vs";
            QueryStringKeys["hideSplashKey"] = "hidesplash";
            QueryStringKeys["V2SplashKey"] = "V2Splash";
            QueryStringKeys["menuItem"] = "mi";
            QueryStringKeys["formName"] = "f";
            QueryStringKeys["limitedNav"] = "limitednav";
            QueryStringKeys["embedded"] = "embedded";
            QueryStringKeys["browserActivityKey"] = "bid";
            QueryStringKeys["activityKey"] = "aid";
            QueryStringKeys["expirationKey"] = "exp";
            QueryStringKeys["financialReportingViewerKey"] = "financialreportingviewerquery";
            QueryStringKeys["officeNavBarKey"] = "officenavbar";
            QueryStringKeys["pageType"] = "pageType";
        })(QueryStringKeys = shell.QueryStringKeys || (shell.QueryStringKeys = {}));
        /**
         * True during the initial boot of client
         * @internal
         */
        shell.isShellInitializing = $dyn.observable(false);
        shell.rootPath = ""; // this points to app root, which can be different from the html location
        shell.buildThemeValue = 0; // build may override for High density
        shell.isSingleThemed = null;
        shell.hideSplash = false;
        shell.officeNavBarKey = false;
        shell.bodyFocusCorrection = true;
        shell.canUseLocalStorage = $dyn.util.localStorageSupported();
        shell.isAsidePaneOpen = $dyn.observable(false);
        shell.isTaskRecorderToolbarOpen = $dyn.observable(false);
        /**
         * If true, pre-processing--typically during static loading--is occuring.
         * @internal
         */
        shell.isPreProcessing = false;
        /**
         * Set to true if the popstate handler finds that the user has tried to use browser.back to navigate away from the product.
         * @internal
         */
        shell.isExiting = false;
        shell.isClosingOpenForms = false;
        shell.closingAllIndex = null;
        shell.closingAllCallback = null;
        shell.closingErrorCallback = null;
        shell.closingAllCloseDashboard = false;
        shell.closingAllDestinationCompany = null;
        shell.closingAllRetainCrumb = false;
        shell.queuedFocusCallbacks = [];
        shell.blockingDivAllowedEvents = [];
        shell.NavBarDocumentId = "NavBar";
        shell.MessageCenterEmbeddedId = "MessageCenterEmbedded";
        shell.CompanyDocumentId = "Company";
        shell.UserDocumentId = "User";
        shell.companyElement = null;
        shell.processingTimer = 1000;
        shell.CurrentFormViewportSize = null;
        shell.CurrentShellViewPortSize = null;
        shell.CurrentShellViewPortWidthSize = null;
        shell.formViewportSizeEvent = "viewportSizeEvent";
        shell.shellViewportSizeEvent = "shellViewportSizeEvent";
        shell.shellViewportWidthSizeEvent = "shellViewportWidthSizeEvent";
        shell.FavIconUrl = "";
        shell.SplashScreenImageUrl = "";
        shell.SplashScreenAnimation = "";
        shell.ProductShortName = $dyn.observable("");
        shell.ProductShortNameHelpText = $dyn.observable($dyn.label("NavBar_GoToDashboard"));
        shell.ProductName = $dyn.observable("");
        shell.OperatedByName = $dyn.observable("");
        shell.ProductId = "";
        shell._ariaLiveMessage = "";
        shell._ariaLiveMessageFireTimer = null;
        shell.__ariaLiveMessageDiv = null;
        shell._ariaLiveMessagesAdded = {};
        shell.asidePaneWidth = $dyn.observable("");
        shell.zoomModeWidth = $dyn.observable(false);
        shell.zoomModeHeight = $dyn.observable(false);
        /**
         * Available viewport sizes to show the main form content
         */
        var ViewportSize;
        (function (ViewportSize) {
            ViewportSize[ViewportSize["Small"] = 0] = "Small";
            ViewportSize[ViewportSize["Medium"] = 1] = "Medium";
            ViewportSize[ViewportSize["Large"] = 2] = "Large";
            ViewportSize[ViewportSize["XLarge"] = 3] = "XLarge";
        })(ViewportSize = shell.ViewportSize || (shell.ViewportSize = {}));
        /**
         * Available Navigation Bar viewport sizes for responsive.
         */
        /* make sure these values are in sync with constants.less */
        var NavBarSizes;
        (function (NavBarSizes) {
            NavBarSizes[NavBarSizes["xsmallNavBarSize"] = 400] = "xsmallNavBarSize";
            NavBarSizes[NavBarSizes["smallNavBarSize"] = 640] = "smallNavBarSize";
            NavBarSizes[NavBarSizes["mediumNavBarSize"] = 800] = "mediumNavBarSize";
            NavBarSizes[NavBarSizes["largeNavBarSize"] = 959] = "largeNavBarSize";
            NavBarSizes[NavBarSizes["xlargeNavBarSize"] = 1366] = "xlargeNavBarSize";
            NavBarSizes[NavBarSizes["xxlargeNavBarSize"] = 1920] = "xxlargeNavBarSize";
            NavBarSizes[NavBarSizes["xxxlargeNavBarSize"] = 2560] = "xxxlargeNavBarSize";
        })(NavBarSizes = shell.NavBarSizes || (shell.NavBarSizes = {}));
        /**
         * Available Shell viewport width sizes for responsive.
         */
        /* make sure these values are in sync with constants.less */
        var ShellViewPortSizes;
        (function (ShellViewPortSizes) {
            ShellViewPortSizes[ShellViewPortSizes["xsmallScreenSize"] = 320] = "xsmallScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["smallScreenSize"] = 480] = "smallScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["mediumScreenSize"] = 640] = "mediumScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["largeScreenSize"] = 960] = "largeScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["xlargeScreenSize"] = 1366] = "xlargeScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["xxlargeScreenSize"] = 1920] = "xxlargeScreenSize";
            ShellViewPortSizes[ShellViewPortSizes["xxxlargeScreenSize"] = 2560] = "xxxlargeScreenSize";
        })(ShellViewPortSizes = shell.ShellViewPortSizes || (shell.ShellViewPortSizes = {}));
        /**
         * Available Shell viewport height sizes for responsive.
         */
        /* make sure these values are in sync with constants.less */
        var ShellViewPortHeightSizes;
        (function (ShellViewPortHeightSizes) {
            ShellViewPortHeightSizes[ShellViewPortHeightSizes["smallScreenSize"] = 500] = "smallScreenSize";
        })(ShellViewPortHeightSizes = shell.ShellViewPortHeightSizes || (shell.ShellViewPortHeightSizes = {}));
        /**
         * Viewport constants that are based on the display density.
         * @internal
         */
        shell.CurrentViewportSizes = _viewportSizesPreDensity[30]; // smallest viewport sizes for current density (default density = 30)
        /**
         * Indicates if an extended event loop is currently on. For more info see startExtendedEventLoop
         * @internal
         */
        shell.extendedEventLoopOn = $dyn.observable(false);
        /**
         * This is a function that should be overridden by the consuming framework to open a specific help pane.
         * @internal
         * @abstract
         */
        shell.openHelpPane = function () { };
        function pack() {
            var packed = {
                ProductName: $dyn.value($dyn.shell.ProductName),
                OperatedByName: $dyn.value($dyn.shell.OperatedByName),
            };
            return packed;
        }
        shell.pack = pack;
        function unpack(packed) {
            if (packed) {
                $dyn.shell.ProductName(packed.ProductName);
                $dyn.shell.OperatedByName(packed.OperatedByName);
            }
        }
        shell.unpack = unpack;
        function buildHelpMenu() {
            if (!$dyn.restrictedNavigation) {
                // dont load until the initial form is requested
                $dyn.deferred.onTrue(function () { return $dyn.value($dyn.shell.clientInitialFormRequested); }).done(function () {
                    $dyn.ui.getNavBar()._getNavMenu("SysMenuHelp", $dyn.ui.getNavBar().helpMenu);
                });
            }
        }
        shell.buildHelpMenu = buildHelpMenu;
        /**
         * Adds messages to the AriaAlertDiv
         * @param messageString string to announce
         */
        function addAriaAlertMessage(messageString) {
            if ($dyn.shell._ariaLiveMessagesAdded[messageString]) {
                // The message has already been added
                return;
            }
            else {
                $dyn.shell._ariaLiveMessagesAdded[messageString] = true;
            }
            if (!$dyn.shell.__ariaLiveMessageDiv) {
                $dyn.shell.__ariaLiveMessageDiv = document.getElementById("AriaAlertArea");
            }
            if ($dyn.shell.__ariaLiveMessageDiv) {
                $dyn.shell._ariaLiveMessage = $dyn.shell._ariaLiveMessage + " " + messageString;
                if ($dyn.shell._ariaLiveMessageFireTimer) {
                    window.clearTimeout($dyn.shell._ariaLiveMessageFireTimer);
                    $dyn.shell._ariaLiveMessageFireTimer = undefined;
                }
                if (!$dyn.shell._ariaLiveMessageFireTimer) {
                    $dyn.shell._ariaLiveMessageFireTimer = window.setTimeout(function () {
                        if ($dyn.shell.__ariaLiveMessageDiv && $dyn.shell.__ariaLiveMessageDiv.textContent !== $dyn.shell._ariaLiveMessage) {
                            $dyn.shell.__ariaLiveMessageDiv.textContent = $dyn.shell._ariaLiveMessage;
                        }
                        $dyn.shell._ariaLiveMessage = "";
                        $dyn.shell._ariaLiveMessageFireTimer = undefined;
                        $dyn.shell._ariaLiveMessagesAdded = {};
                    }, 250);
                }
            }
        }
        shell.addAriaAlertMessage = addAriaAlertMessage;
        function setControlLibraryCultureSettings() {
            $.when($dyn.deferred.onTrue(function () {
                return $dyn.value($dyn.util.controlLibraryResourcesLoaded);
            })).done(function () {
                var locManager = ControlLibrary.LocalizationManager.instance;
                var culture = Globalize.culture();
                locManager.setDateFormat(culture.calendar.patterns.d);
                locManager.setTimeFormat(culture.calendar.patterns.t);
                locManager.setDateTimeFormat("{1} {0}");
                locManager.setNumberFormat(culture.numberFormat);
                locManager.setTimeSeparator(culture.calendar[":"]);
                locManager.setMonthNames(culture.calendar.months);
                locManager.setDayNames(culture.calendar.days);
                locManager.setFirstDayOfWeek(culture.calendar.firstDay);
            });
        }
        shell.setControlLibraryCultureSettings = setControlLibraryCultureSettings;
        shell.controlLibMessagePrefix = "ControlLib_";
        /**
         * This function handles setting the messages for the control library
         * @internal
         */
        function setControlLibraryMessages() {
            var controlLibPrefixLength = $dyn.shell.controlLibMessagePrefix.length;
            var messages = Globalize.culture().messages;
            var controlLibraryMessages = {};
            for (var messageKey in messages) {
                if (messageKey.startsWith($dyn.shell.controlLibMessagePrefix)) {
                    controlLibraryMessages[messageKey.substring(controlLibPrefixLength)] = messages[messageKey];
                }
            }
            // Re-use labels
            controlLibraryMessages.DatePicker_Clear = $dyn.label("Input_DatePickerClear");
            controlLibraryMessages.GroupHeader_Collapse = $dyn.label("Group_Collapse");
            controlLibraryMessages.GroupHeader_Expand = $dyn.label("Group_Expand");
            ControlLibrary.LocalizationManager.instance.setMessages(controlLibraryMessages);
        }
        shell.setControlLibraryMessages = setControlLibraryMessages;
        /**
         * This function handles loading the resources for the control library
         * @internal
         */
        function loadControlLibraryResources() {
            if (!$dyn.value($dyn.util.controlLibraryResourcesLoaded)) {
                $dyn.async.pending.increment("Loading Control Library resources");
                // Load css for fixed-data-table
                var newLink = document.createElement("link");
                newLink.href = $dyn.shell.rootPath + "Resources/styles/ext/fixed-data-table.min.css";
                newLink.rel = "stylesheet";
                newLink.type = "text/css";
                document.head.appendChild(newLink);
                // Load control library scripts async while it is behind a flag and in prototype mode
                var newScript = document.createElement("script");
                var importUrl = $dyn.shell.rootPath;
                if ($dyn.IsDebugBuild) {
                    importUrl += "Scripts/ext/controlLibrary/debug/controlLibrary.665766a647b4a63fc717.js";
                }
                else {
                    importUrl += "Scripts/ext/controlLibrary/release/controlLibrary.6f9b48eb5349bb83822a.min.js";
                }
                newScript.setAttribute("src", importUrl);
                var scriptLoadHandler = function () {
                    $dyn.observe($dyn.user().Language, $dyn.shell.setControlLibraryMessages);
                    // Handle initial React Theme loading
                    $dyn.observe($dyn.user().Theme, function (newTheme) {
                        if (newTheme >= 0) {
                            $dyn.densityThemeManager.updateReactTheme();
                            return false;
                        }
                    });
                    $dyn.setValue($dyn.util, "controlLibraryResourcesLoaded", true);
                    $dyn.shell.setControlLibraryCultureSettings();
                    $dyn.async.pending.decrement("Finished loading Control Library resources");
                };
                newScript.onload = scriptLoadHandler;
                document.head.appendChild(newScript);
            }
        }
        shell.loadControlLibraryResources = loadControlLibraryResources;
        /**
         * This function handles setting the product name
         * @internal
         */
        function setProductName() {
            if ($dyn.util.isPreviewBuild()) {
                $dyn.shell.ProductShortName($dyn.value($dyn.shell.ProductShortName()) + " " + $dyn.label("Product_IsPreview"));
                $dyn.shell.ProductName($dyn.value($dyn.shell.ProductName) + " " + $dyn.label("Product_IsPreview"));
            }
        }
        shell.setProductName = setProductName;
        function taskRecorderFocusHandler() {
            $dyn.shell.updateActiveFocusRegion("TaskRecorderToolbar");
        }
        shell.taskRecorderFocusHandler = taskRecorderFocusHandler;
        function asidePaneFocusHandler() {
            $dyn.shell.updateActiveFocusRegion("AsidePane");
        }
        shell.asidePaneFocusHandler = asidePaneFocusHandler;
        function mainPaneFocusHandler() {
            $dyn.shell.updateActiveFocusRegion("MainPane");
        }
        shell.mainPaneFocusHandler = mainPaneFocusHandler;
        function updateActiveFocusRegion(focusRegion) {
            $dyn.shell._activeRegion = focusRegion;
        }
        shell.updateActiveFocusRegion = updateActiveFocusRegion;
        function getActiveRegion() {
            return $dyn.shell._activeRegion;
        }
        shell.getActiveRegion = getActiveRegion;
        /**
         * This function handles setting the various elements that use product name
         * @internal
         * @param productName product name
         */
        function updateProductNameItems(productName) {
            if (productName) {
                $dyn.shell.ProductShortName(productName);
                $dyn.shell.BrowserTitleFormat = $dyn.shell.BrowserTitleFormat + $dyn.shell.ProductShortName();
                $dyn.htmlDocument.setMetaValue("application-name", $dyn.shell.ProductShortName(), "");
            }
        }
        shell.updateProductNameItems = updateProductNameItems;
        /**
         * This function handles reading the $dyn.appconfig file and setting specific elements.
         * @internal
         */
        function loadAppSpecificItems() {
            /**
             * This function reads the appconfig values and sets appropriate elements
             * @internal
             */
            function setAppConfig() {
                if ($dyn.appConfig) {
                    if ($dyn.appConfig.noNavigationPane === "true") {
                        $dyn.shell._noNavigationPane = true;
                    }
                    if ($dyn.appConfig.navigationMode === "Workspace") {
                        $dyn.shell._isWorkspaceNavigationMode = true;
                    }
                    // build the app short name
                    if ($dyn.appConfig.appShortTitle) {
                        $dyn.shell.updateProductNameItems($dyn.appConfig.appShortTitle);
                    }
                    if ($dyn.appConfig.appTitle) {
                        $dyn.shell.ProductName($dyn.appConfig.appTitle);
                    }
                    if ($dyn.appConfig.appId) {
                        $dyn.shell.ProductId = $dyn.appConfig.appId;
                    }
                    if ($dyn.appConfig["msapplication-tooltip"]) {
                        $dyn.htmlDocument.setMetaValue("msapplication-tooltip", $dyn.appConfig["msapplication-tooltip"], "");
                    }
                    if ($dyn.appConfig.images) {
                        if ($dyn.appConfig.images.favIconUrl && $dyn.appConfig.images.favIconName === undefined) {
                            $dyn.shell.FavIconUrl = $dyn.appConfig.images.favIconUrl;
                            $dyn.htmlDocument.setFavicon($dyn.shell.FavIconUrl);
                        }
                        // set up tile images only if the image path is not defined
                        if ($dyn.appConfig.images.tileImagesUrl === undefined) {
                            // meta and link tags
                            if ($dyn.appConfig.images["msapplication-TileImage"]) {
                                $dyn.htmlDocument.setMetaValue("msapplication-TileImage", $dyn.appConfig.images["msapplication-TileImage"], "");
                            }
                            if ($dyn.appConfig.images["apple-touch-icon"]) {
                                $dyn.htmlDocument.setLinkIconValue("apple-touch-icon", $dyn.appConfig.images["apple-touch-icon"], "");
                            }
                        }
                    }
                }
            }
            /**
             * This function setups the calls to load the app config settings
             * @internal
             */
            function loadAppConfig() {
                setAppConfig();
                document.title = $dyn.shell.ProductShortName();
                // dont request until the initial form is requested
                $dyn.deferred.onTrue(function () { return $dyn.value($dyn.shell.clientInitialFormRequested); }).done(function () {
                    if (!$dyn.restrictedNavigation && !$dyn.shell._noNavigationPane) {
                        // get pin state
                        $dyn.DynReact.ModuleStore.getMenuPaneSettings(function (pinValue) {
                            if (!$dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                                var returnVal = pinValue === "1" ? true : false;
                                if ($dyn.shell.CurrentShellViewPortSize === $dyn.shell.ViewportSize.Small) {
                                    // Don't show pin button in small viewport and unpin
                                    if ($dyn.value($dyn.shell.isNavigationPanePinned)) {
                                        $dyn.shell.toggleIsNavigationPanePinned({ skipSaveValue: true });
                                    }
                                }
                                else if ($dyn.value($dyn.shell.isNavigationPanePinned) !== returnVal) {
                                    $dyn.shell.toggleIsNavigationPanePinned({ skipSaveValue: true });
                                }
                            }
                            else {
                                $dyn.shell.mainPane.classList.add("modulesPane-isWorkspaceMode");
                            }
                        });
                        if ($dyn.shell.isPhone && !$dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                            $dyn.shell.isNavigationPanePinned(true);
                        }
                        // Save off the modulesPane element
                        $dyn.shell._modulesPaneElement = document.getElementsByClassName("modulesPane")[0];
                        // fire initial view port sizer event
                        $dyn.shell.viewportSizeChanged();
                    }
                    else {
                        // No gutter (or Navigation Pane) for popouts or limitedNav.
                        $dyn.shell.mainPane.classList.add("gutter-isHidden");
                        $dyn.shell.mainPane.classList.remove("modulesPane-isPinned");
                    }
                });
            }
            if (document.readyState === "complete") {
                // the load event has already occurred, so load the config settings and set resize event
                loadAppConfig();
            }
            else {
                $dyn.async.pending.increment("load listener");
                window.addEventListener("load", function load(event) {
                    // remove listener, no longer needed
                    window.removeEventListener("load", load, false);
                    loadAppConfig();
                    $dyn.async.pending.decrement("load listener");
                }, false);
            }
        }
        shell.loadAppSpecificItems = loadAppSpecificItems;
        /**
         * Starts an ongoing extended event loop.
         * @description Shell supports extended interaction loop that can span multiple native event loops of the browser. Starting an extended loop
         * would keep the loop on until a matching number of endExtendedEventLoop's are called. An extended event loop can be canceled by calling cancelExtendedEventLoop.
         * If more endExtendedEventLoop's are called, the extra endExtendedEventLoop's are ignored.
         * @internal
         */
        function startExtendedEventLoop() {
            $dyn.shell._extendedEventLoopCount++;
            if ($dyn.shell._extendedEventLoopCount === 1) {
                $dyn.shell.extendedEventLoopOn(true);
            }
        }
        shell.startExtendedEventLoop = startExtendedEventLoop;
        /**
         * Ends an ongoing extended event loop.
         * @description For more info see {@link $dyn.shell.startExtendedEventLoop}
         * @internal
         */
        function endExtendedEventLoop() {
            $dyn.shell._extendedEventLoopCount > 0 && $dyn.shell._extendedEventLoopCount--;
            if ($dyn.shell._extendedEventLoopCount === 0) {
                $dyn.shell.extendedEventLoopOn(false);
            }
        }
        shell.endExtendedEventLoop = endExtendedEventLoop;
        /**
         * The click event handler
         * @private
         * @param calledFunction constant determining which renderer function to call
         * @param evt triggered event
         */
        function callCommandButtonFunction(calledFunction, evt) {
            // We handle this command client side so prevent the default action
            // and initiate the action.
            var button = evt.target;
            var buttonContext;
            if (button) {
                buttonContext = $dyn.context(button);
            }
            if (buttonContext && buttonContext.Root) {
                var formElement = buttonContext.Root.element;
                if (formElement) {
                    var gridControls = $(formElement).find('[data-dyn-role="List"]');
                    var listContext = void 0;
                    if (gridControls && buttonContext) {
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < gridControls.length; i++) {
                            listContext = $dyn.context(gridControls[i]);
                            // Assumption here is, grid who has pending rows associated with it is the grid who initiated delete action.
                            // Grid with pending rows will turn on rails mode and hence other grids should not be actionable.
                            if (listContext && listContext.ServiceBoundary && buttonContext.ServiceBoundary && $dyn.value(listContext.ServiceBoundary) === $dyn.value(buttonContext.ServiceBoundary)) {
                                if (calledFunction === CalledCommandButtonFunction.DeleteRecord && !$dyn.peek(listContext._syncManager.isQueueEmpty)) {
                                    break;
                                }
                                else if (calledFunction === CalledCommandButtonFunction.New) {
                                    break;
                                }
                                else {
                                    listContext = null;
                                }
                            }
                            else {
                                listContext = null;
                            }
                        }
                    }
                    if (listContext) {
                        var targetRowElement = listContext._renderer.getUserSelectedElement();
                        if (calledFunction === CalledCommandButtonFunction.New) {
                            if (listContext._newRecord(targetRowElement)) {
                                if (evt) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                }
                            }
                        }
                        else if (calledFunction === CalledCommandButtonFunction.DeleteRecord) {
                            listContext._renderer.deleteRecord(targetRowElement, evt);
                        }
                    }
                }
            }
        }
        shell.callCommandButtonFunction = callCommandButtonFunction;
        /**
         * Terminates an ongoing extended event loop regardless of how many startExtendedEventLoop's were previously called.
         * Remaining calls to endExtendedEventLoop are ignored.
         * @internal
         */
        function cancelExtendedEventLoop() {
            $dyn.shell._extendedEventLoopCount = 0;
            $dyn.shell.extendedEventLoopOn(false);
        }
        shell.cancelExtendedEventLoop = cancelExtendedEventLoop;
        function giveNavBarFocus() {
            $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GiveNavBarFocus)");
            if ($dyn.ui.getNavBar().element.contains(document.activeElement)) {
                var form = $dyn.context($dyn.shell.getActiveForm());
                if (form) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GiveNavBarFocus) return focus to form Id: %s calling takeNavigationFocus", form.Id);
                    form.takeNavigationFocus();
                }
            }
            else {
                var firstTabbable = $dyn.util.findFirstTabbableControl($dyn.ui.getNavBar().element);
                if (firstTabbable) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GiveNavBarFocus) focus nav bar");
                    firstTabbable.focus();
                }
            }
        }
        shell.giveNavBarFocus = giveNavBarFocus;
        shell.Shortcuts = __assign(__assign(__assign(__assign({ 
            // Ignore Ctrl+G on shell and stop propagation
            IgnoreCtrlG: {
                Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterG },
                Handler: function (evt) {
                    return true;
                },
                Force: true,
                ShowToUser: false,
            }, 
            // TODO: Toggle open/close? Move focus?
            GoToMessageCenter: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.f7 },
                Handler: function (evt) {
                    if (!$dyn.restrictedNavigation || $dyn.isEmbedded) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GoToMessageCenter)");
                        // Put focus on notification popup if popup is active
                        if ($dyn.value($dyn.messaging.MessageCenterManager.notificationPopupVisible)) {
                            $dyn.messaging.MessageCenterManager.FocusOnNotificationPopup();
                        }
                        else {
                            $dyn.messaging.MessageCenterManager.messageCenterVisible(true);
                        }
                    }
                },
                Description: $dyn.label("Shell_OpenMessageCenter"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            } }, !$dyn.restrictedNavigation && {
            GoToCompanyPicker: {
                Keys: { ctrl: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterO },
                Handler: function () {
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GoToCompanyPicker)");
                    if (!$dyn.shell.companyElement) {
                        $dyn.shell.companyElement = $($dyn.ui.getNavBar().element).find(".navigationBar-companyButton")[0];
                    }
                    if ($dyn.shell.companyElement) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GoToCompanyPicker) open company picker");
                        $dyn.shell.companyElement.click();
                    }
                },
                Description: $dyn.label("Shell_OpenCompanyPicker"),
            },
        }), { GoToFormContainer: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterM },
                Handler: function (evt) {
                    var form = $dyn.context($dyn.shell.getActiveForm());
                    if (form) {
                        if ($dyn.ui.getNavBar().element.contains(evt.target)) {
                            form.takeNavigationFocus();
                        }
                        else {
                            form.RestoreFocusToMainFormContainer();
                        }
                    }
                },
                Description: $dyn.label("Shell_MainFormContainer"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            } }), !$dyn.restrictedNavigation && {
            GoToHome: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.home },
                Handler: function () {
                    $dyn.ui.getNavBar().navigateToDashboard();
                },
                ShowToUser: function () {
                    return !$dyn.restrictedNavigation;
                },
                Description: $dyn.label("Shell_GoHome"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            GoToTaskRecorder: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterO },
                Handler: function () {
                    var isSetFocusToTaskRecorderPane = false;
                    if (!$dyn.shell.isTaskRecorderOpen() && !$dyn.shell.isTaskRecorderGuideOpen() && !$dyn.value($dyn.ax.taskRecording.isRecording)) {
                        // a task recorder form was not previously open, so open the task recorder
                        $dyn.ax.taskRecording.open();
                        isSetFocusToTaskRecorderPane = true;
                    }
                    else if ($dyn.value($dyn.ax.taskRecording.isRecording) && !$dyn.shell.isTaskRecorderGuideOpen()) {
                        // a recording is being made or played back, but the task recorder guide is not visible
                        $dyn.ax.taskRecording.toolbarOpenPane();
                        isSetFocusToTaskRecorderPane = true;
                    }
                    else if (($dyn.shell.isTaskRecorderOpen() || $dyn.shell.isTaskRecorderGuideOpen()) &&
                        !$(document.activeElement)
                            .parents()
                            .hasClass("asidePane")) {
                        // task recorder was already open, but it is not the active form
                        isSetFocusToTaskRecorderPane = true;
                    }
                    if (isSetFocusToTaskRecorderPane) {
                        // set the focus to the task recorder pane
                        var taskPaneElement = document.querySelector('[data-dyn-form-name="TaskRecorderPane"]');
                        if (taskPaneElement) {
                            $dyn.ax.taskRecording.setTaskRecorderFocus();
                        }
                        else {
                            if (!$dyn.value($dyn.ax.taskRecording.isRecording)) {
                                $dyn.ax.taskRecording.setTaskGuideFocus();
                            }
                            else {
                                var asidePaneContext = $dyn.context($dyn.shell.getActiveAsideForm());
                                if (asidePaneContext) {
                                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GoToTaskRecorder) return focus to aside pane, form Id: %s calling takeNavigationFocus", asidePaneContext.Id);
                                    asidePaneContext.takeNavigationFocus();
                                }
                            }
                        }
                    }
                    else {
                        // toggle the focus from the task recorder form back to the current form
                        var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                        if (activeForm_1) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(GoToTaskRecorder) return focus to form Id: %s calling takeNavigationFocus", activeForm_1.Id);
                            activeForm_1.takeNavigationFocus();
                        }
                    }
                },
                Description: function () {
                    return $dyn.shell.isTaskRecorderOpen() ? $dyn.label("Shell_MoveFocusToTaskRecorder") : $dyn.label("Shell_OpenTaskRecorder");
                },
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            GoToTracing: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterT },
                Handler: function () {
                    $dyn.ax._tracing.open();
                },
                Description: $dyn.label("Shell_OpenTraceParser"),
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            GiveNavBarFocus: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterN },
                Handler: function () {
                    $dyn.shell.giveNavBarFocus();
                },
                Description: function (target) {
                    var description = "";
                    if ($dyn.ui.getNavBar().element.contains(target)) {
                        description = $dyn.label("Shell_MainFormContainer");
                    }
                    else {
                        description = $dyn.label("Shell_GoToNavBar");
                    }
                    return description;
                },
                Category: $dyn.ui.ShortcutCategory.Navigate,
            },
            GiveNavBarFocusAlt: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.f1 },
                Handler: function () {
                    $dyn.shell.giveNavBarFocus();
                },
                ShowToUser: false,
            },
            ToggleNavigationPaneState: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.f1 },
                Handler: function (event) {
                    if ($dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                        if (!$dyn.value($dyn.shell.isNavigationPanePinned)) {
                            // Open when closed
                            $dyn.shell.toggleIsNavigationPanePinned();
                        }
                        else if (!$dyn.shell.eventIsInNavigationPane(event)) {
                            // Take focus when focus is outside of the (pinned) navigation pane
                            $dyn.shell._renderNavigationPane(); // componentDidUpdate will pull focus where it is needed.
                        }
                        else {
                            // Collapse the gutter pane
                            $dyn.shell.toggleIsNavigationPanePinned();
                        }
                        var firstElement = $dyn.shell._modulesPaneElement.querySelector(".gutterPane-link");
                        firstElement && firstElement.focus();
                        $dyn.log.focus && $dyn.log.focus("Focus: NavigationPane focused first navigation bar element.");
                    }
                    else {
                        if (!$dyn.shell._navigationPaneIsOpen) {
                            // Open when closed
                            $dyn.shell.setNavigationPaneIsOpen(true);
                        }
                        else if (!$dyn.shell.eventIsInNavigationPane(event)) {
                            // Take focus when focus is outside of the (pinned) navigation pane
                            $dyn.shell._renderNavigationPane(); // componentDidUpdate will pull focus where it is needed.
                        }
                        else {
                            // Pin if open and focused, unpin if already pinned
                            $dyn.shell.toggleIsNavigationPanePinned();
                        }
                    }
                },
                Description: function (target) {
                    var description = "";
                    if ($dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                        if (!$dyn.value($dyn.shell.isNavigationPanePinned)) {
                            description = $dyn.label("Shell_OpenNavPane");
                        }
                        else if ($(target).closest(".modulesPane").length === 0) {
                            description = $dyn.label("Shell_GoToNavPane");
                        }
                        else {
                            description = $dyn.label("Shell_CloseNavPane");
                        }
                    }
                    else {
                        if (!$dyn.shell._navigationPaneIsOpen) {
                            description = $dyn.label("Shell_OpenNavPane");
                        }
                        else if ($(target).closest(".modulesPane").length === 0) {
                            description = $dyn.label("Shell_GoToNavPane");
                        }
                        else {
                            description = $dyn.label("Shell_CloseNavPane");
                        }
                    }
                    return description;
                },
            },
        }), { FocusNextWhatsNew: {
                ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterM },
                Keys: { keyCode: $dyn.ui.KeyCodes.letterC },
                Handler: function () {
                    $dyn.whatsNew.moveNextWhatsNewFocus();
                },
                ShowToUser: function () {
                    return $dyn.whatsNew.areWhatsNewShown();
                },
                Description: function () {
                    return $dyn.label("WhatsNew_ShortCutDescription");
                },
                Category: $dyn.ui.ShortcutCategory.Navigate,
            } });
        function loadBlockingDivs() {
            if ($dyn.shell.blockingDiv === undefined) {
                $dyn.shell.blockingDiv = document.getElementById("ShellBlockingDiv");
                $dyn.shell.blockingDiv.style.display = "none";
            }
            if ($dyn.shell._shellProcessingDiv === undefined) {
                $dyn.shell._shellProcessingDiv = document.getElementById("ShellProcessingDiv");
                $dyn.shell._shellProcessingDiv.style.display = "none";
            }
        }
        shell.loadBlockingDivs = loadBlockingDivs;
        function init() {
            // should we show the splash do this immediatly
            if ($dyn.debug.vs || !!$dyn.util.location.query[$dyn.shell.QueryStringKeys.hideSplashKey] || $dyn.shell.isSingleThemed) {
                $dyn.shell.hideSplash = true;
                $("#splashScreen").css("visibility", "hidden");
            }
            else {
                if ($dyn.util.location.query[$dyn.shell.QueryStringKeys.V2SplashKey]) {
                    $("#logoV2").css("display", "inline");
                }
                else {
                    $("#logoV1").css("display", "inline");
                }
                $("#splashScreen").css("visibility", "visible");
            }
            $dyn.util.internetReachable();
            // Subscribes the code to trigger layout when the $dyn.ui.layout flag changes to false.
            $dyn.layout.subscribeArrangeToLayout();
            $dyn.shell.subscribeAsidePaneToggle();
            $dyn.shell.browserInit();
            $dyn.shell.loadBlockingDivs();
            $dyn.shell.documentTitleInit();
            // Initialize the user element
            $dyn.shell.initializeUser();
            // Initialize user query string settings (cmp, prt, lng, theme, density)
            $dyn.shell.initializeUserSettingsFromURL();
            // Read appconfig file and initialize
            $dyn.shell.loadAppSpecificItems();
            // Initialize browser activity settings (browser activity id, activity id)
            $dyn.shell.initializeBrowserActivityFromURL();
            $dyn.shell.setContainersWithBorderRadius();
            // check if we need to enable RTL
            $dyn.shell.setBodyLanguageMode();
            // Actives the nav bar for layout to occur
            $dyn.shell.activateNavBar();
            $dyn.shell.setDeviceMode();
            // check if we need to force the shellinit to be off based on single theme flag from tt files
            if ($dyn.shell.isSingleThemed || $dyn.debug.settings) {
                $dyn.shell.displayFirstRendering();
            }
            window.addEventListener("focus", $dyn.shell.onWindowFocus);
            window.addEventListener("blur", $dyn.shell.onWindowBlur);
            document.body.addEventListener("selectstart", function (event) {
                var target = event.target;
                // A DOM element can be set with the css unselectable to make them unselectable
                if (target && target.classList && target.classList.contains("unselectable")) {
                    $dyn.log.shell && $dyn.log.shell("Shell: Preventing focus of unselectable element: %s", target);
                    event.preventDefault();
                }
            });
            $(document).on("ajaxError", function (event, request, settings, thrownError) {
                if (thrownError) {
                    $dyn.logWarning(thrownError);
                }
            });
            $dyn.shell._registerDensityChangeHandler();
            if (!!$dyn.util.location.query[$dyn.shell.QueryStringKeys.officeNavBarKey] || $dyn.flags.officeNavBar) {
                var navBar = $dyn.ui.getNavBar();
                navBar.OfficeNavBarVisible(true);
            }
        }
        shell.init = init;
        Object.defineProperty($dyn.shell, "mainPane", {
            get: function () {
                if (!$dyn.shell._mainPane) {
                    $dyn.shell._mainPane = document.querySelector("#mainPane");
                }
                return $dyn.shell._mainPane;
            }
        });
        Object.defineProperty($dyn.shell, "chordNotification", {
            get: function () {
                if (!$dyn.shell._chordNotification) {
                    $dyn.shell._chordNotification = document.querySelector("#ChordNotification");
                }
                return $dyn.shell._chordNotification;
            }
        });
        /**
         * Setup a function to get called in a timeout when the window resize event happens
         * @description The timeout is needed because the resize event gets fired many times while the window
         * is resizing. Thus we only want our handler to get called once when the user has finished resizing.
         * @internal
         * @param handler Function to be called when the window is done resizing
         * @param thisArg The this context the handler is to be called with
         * @returns The id of the resize handler
         */
        function subscribeWindowResize(handler, thisArg) {
            if (!$dyn.shell.resizeHandlers) {
                $dyn.shell.resizeHandlers = {};
                $dyn.shell._resizeHandlerId = 0;
            }
            $dyn.shell._resizeHandlerId++;
            var funcOptions = {
                func: handler,
                thisArg: thisArg,
            };
            $dyn.shell.resizeHandlers[$dyn.shell._resizeHandlerId] = funcOptions;
            return $dyn.shell._resizeHandlerId;
        }
        shell.subscribeWindowResize = subscribeWindowResize;
        /**
         * Unsubscribe a handler setup using the {@link $dyn.shell.subscribeWindowResize} function
         * @internal
         * @param handlerId The id of the resize handler
         */
        function unsubscribeWindowResize(handlerId) {
            if ($dyn.shell.resizeHandlers) {
                delete $dyn.shell.resizeHandlers[handlerId];
            }
        }
        shell.unsubscribeWindowResize = unsubscribeWindowResize;
        function clearBodyFocusCorrection() {
            var oldValue = $dyn.shell.bodyFocusCorrection;
            $dyn.shell.bodyFocusCorrection = false;
            return oldValue;
        }
        shell.clearBodyFocusCorrection = clearBodyFocusCorrection;
        /**
         * Returns true if the code is being executed in the currently active browser window.
         * @internal
         */
        function isActiveWindow() {
            if ($dyn.serverForm && $dyn.serverForm._windowManager) {
                return $dyn.serverForm._windowManager.isFocused();
            }
            else {
                return true;
            }
        }
        shell.isActiveWindow = isActiveWindow;
        function onWindowFocus() {
            if ($dyn.serverForm && $dyn.serverForm._windowManager) {
                $dyn.serverForm._windowManager.focusWindow();
            }
            for (var i = 0, len = $dyn.shell.queuedFocusCallbacks.length; i < len; i++) {
                // Invoke the callback and then delete it from the array.
                $dyn.callFunction($dyn.shell.queuedFocusCallbacks[0].callback, $dyn.shell.queuedFocusCallbacks[0].context, [$dyn.shell.queuedFocusCallbacks[0].focusElement]);
                $dyn.shell.queuedFocusCallbacks.splice(0, 1);
            }
            if ($dyn.shell.overwrittenFocusCallback) {
                $dyn.callFunction($dyn.shell.overwrittenFocusCallback.callback, $dyn.shell.overwrittenFocusCallback.context, [$dyn.shell.overwrittenFocusCallback.focusElement]);
                $dyn.shell.overwrittenFocusCallback = undefined;
            }
        }
        shell.onWindowFocus = onWindowFocus;
        function onWindowBlur() {
            var focusedControl = $dyn.context(document.activeElement);
            if (focusedControl && focusedControl.updateValue) {
                focusedControl.updateValue(true);
            }
        }
        shell.onWindowBlur = onWindowBlur;
        function displayFirstRendering() {
            if ($dyn.shell._formRenderingObserver) {
                $dyn.shell._formRenderingObserver.dispose();
                $dyn.shell._formRenderingObserver = undefined;
            }
            // enable the main container when client is ready
            $dyn.shell._formRenderingObserver = $dyn.observe($dyn.shell.formRenderingComplete, function (renderingComplete) {
                if (renderingComplete) {
                    $("#mainContainer").css("visibility", "visible");
                    // if we are showing the splash - close splash when client is ready
                    if (!$dyn.shell.hideSplash) {
                        $dyn.shell.hideSplash = true;
                        $("#splashScreen").fadeOut($dyn.ui.motionTiming.quick, function () {
                            // setup the session telemetry this is done here as the call to jq.response causes IE to repaint
                            $dyn.telemetry.addSessionBeginEvent();
                        });
                    }
                    else {
                        $dyn.telemetry.addSessionBeginEvent();
                    }
                    // call into NPS service once we are done
                    $dyn._npsHandler.init();
                }
            });
            $dyn.ui.layout(true);
            // turn flag off as the shell is done
            if ($dyn.shell.isShellInitializing()) {
                $dyn.shell.isShellInitializing(false);
                $dyn.async.pending.decrement("Finished initializing isShellInitializing false");
                // restore focus
                var form = $dyn.context($dyn.shell.getActiveForm());
                if (form) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->Finished initializing return focus");
                    form.setControlFocus(form.ActiveControl());
                }
                $dyn.ui.layout(false);
            }
        }
        shell.displayFirstRendering = displayFirstRendering;
        function setContainersWithBorderRadius() {
            // checking if on IE 11 specifically
            if (navigator.userAgent.indexOf("Trident/") === -1) {
                $(document.body).addClass("ContainersWithBorderRadius");
            }
            else {
                $(document.body).removeClass("ContainersWithBorderRadius");
            }
        }
        shell.setContainersWithBorderRadius = setContainersWithBorderRadius;
        function setBodyLanguageMode() {
            var language = Globalize.culture().language;
            document.documentElement.lang = language;
            // Set RTL based on language
            if (Globalize.culture().isRTL || $dyn.debug.useRTL) {
                $(document.body).removeClass("ltr");
                document.documentElement.dir = "rtl";
                $(document.body).addClass("rtl");
            }
            else {
                document.documentElement.dir = "ltr";
                $(document.body).addClass("ltr");
                $(document.body).removeClass("rtl");
            }
            $dyn.shell.optimizeCJKFonts(language);
        }
        shell.setBodyLanguageMode = setBodyLanguageMode;
        /**
         * Depending on the CJK (Chinese, Japanese, Korean) language, optimize which of the native fonts should be used.
         * For Windows specifics, see https://msdn.microsoft.com/en-us/library/windows/desktop/dn742483(v=vs.85).aspx
         * For iOS/Apple specific, see https://en.wikipedia.org/wiki/List_of_CJK_fonts
         * For Android specific, see https://www.google.com/design/spec/style/typography.html#typography-typeface
         */
        function optimizeCJKFonts(language) {
            var fontFamily;
            var fontFaceElement = document.getElementById("ms-dyn-cjkFontFace");
            if (fontFaceElement) {
                document.head.removeChild(fontFaceElement);
            }
            switch (language) {
                case "zh-CHS":
                    fontFamily = "local('Microsoft YaHei UI'), local('HeiTi SC'), local('Noto Sans CJK'), sans-serif";
                    break;
                case "zh-Hant":
                    fontFamily = "local('Microsoft JhengHei UI'), local('HeiTi ST'), local('Noto Sans CJK'), sans-serif";
                    break;
                case "ko":
                    fontFamily = "local('Malgun Gothic'), local('Apple Gothic'), local('Noto Sans CJK'), sans-serif";
                    break;
                case "ja":
                    fontFamily = "local('Yu Gothic UI'), local('Mincho'), local('Noto Sans CJK'), local('Meiryo UI'), sans-serif";
                    break;
            }
            if (fontFamily) {
                fontFaceElement = document.createElement("style");
                fontFaceElement.setAttribute("id", "ms-dyn-cjkFontFace");
                // Note: This should be kept in sync with the default fonts found in Fonts.less.
                var fontFaceDescription = "@font-face {" + "font-family: 'Segoe UI'; " + "src: " + fontFamily + ";" + "font-style: normal;" + "unicode-range: U+A5, U+4E00-9FFF, U+30??, U+FF00-FF9F; }";
                fontFaceElement.innerText = fontFaceDescription;
                document.head.appendChild(fontFaceElement);
            }
        }
        shell.optimizeCJKFonts = optimizeCJKFonts;
        /**
         * Returns a string that that joins the provided elements with a chevron.
         * @description Supports RTL by reversing the order and chevron depending on current display.
         *  Note: Only use when CSS can not be used to allow correct LTR/RTL display switches.
         * @param arr Strings to be joined.
         * @returns array elements joined with ` < ' or ' > ' depending on rtl setting.
         */
        function joinArrayWithChevron(arr) {
            if (document.documentElement.dir === "rtl") {
                return arr.reverse().join(" < ");
            }
            else {
                return arr.join(" > ");
            }
        }
        shell.joinArrayWithChevron = joinArrayWithChevron;
        /**
         * Indicates whether or not the provided rootFormCandidate form is the root of the candidateEnhancedPreviewForm and that candidateEnhancedPreviewForm is an
         * enhanced preview form.
         * @private
         */
        function isFormRootOfEnhancedPreview(candidateEnhancedPreviewForm, rootFormCandidate) {
            return candidateEnhancedPreviewForm && candidateEnhancedPreviewForm.IsPreviewForm && candidateEnhancedPreviewForm.Root === rootFormCandidate;
        }
        shell.isFormRootOfEnhancedPreview = isFormRootOfEnhancedPreview;
        function _registerDensityChangeHandler() {
            var currentUser = $dyn.value($dyn.user);
            // Observe current user density to set the smallest breakpoint size based on current density and call viewportSizeChanged
            if (currentUser) {
                return $dyn.observe(currentUser.Density, function (density) {
                    if (density > 0) {
                        $dyn.shell.CurrentViewportSizes = _viewportSizesPreDensity[density.toString()];
                        $dyn.shell.viewportSizeChanged();
                    }
                });
            }
        }
        shell._registerDensityChangeHandler = _registerDensityChangeHandler;
        /**
         * Called when view port size changes. Raises formViewportSizeEvent and shelViewportSizeEvent for external subscribers.
         * @private
         */
        function viewportSizeChanged(asidePaneOpen) {
            var formNewViewport;
            var shellNewViewport;
            var shellAvailableCols;
            var formAvailableCols;
            // Calculate the available width for content. Form needs to take gutter width into account but shell doesn't.
            var shellViewportWidth = Math.max(document.documentElement.clientWidth || 0);
            // var shellViewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var formViewportWidth = shellViewportWidth - $dyn.shell.CurrentViewportSizes.gutterWidth;
            $dyn.shell._getViewPortSize = function (availableCols) {
                var newViewPort;
                if (availableCols < 2) {
                    // small (one column)
                    newViewPort = $dyn.shell.ViewportSize.Small;
                }
                else if (availableCols === 2) {
                    // medium (two columns)
                    newViewPort = $dyn.shell.ViewportSize.Medium;
                }
                else if (availableCols === 3) {
                    // large (three columns)
                    newViewPort = $dyn.shell.ViewportSize.Large;
                }
                else if (availableCols >= 4) {
                    // xLarge (four or more columns)
                    newViewPort = $dyn.shell.ViewportSize.XLarge;
                }
                return newViewPort;
            };
            $dyn.shell._shellViewPortSizeChanged = function () {
                // Calculate number of columns can fit into viewportWidth
                var shellAvailableCols = Math.floor(shellViewportWidth / $dyn.shell.CurrentViewportSizes.viewportWidth);
                // Close aside pane if there is not enough room.
                if (asidePaneOpen === undefined && shellAvailableCols < 2) {
                    $dyn.shell.hideAsidePane();
                    asidePaneOpen = false;
                }
                // Set the current aside pane visible if it's not provided
                asidePaneOpen = asidePaneOpen || $dyn.value($dyn.shell.isAsidePaneOpen);
                // Reserve column for aside pane if it's opened
                shellAvailableCols = asidePaneOpen === true ? shellAvailableCols - Math.floor($dyn.shell._asidePane.offsetWidth / $dyn.shell.CurrentViewportSizes.viewportWidth) : shellAvailableCols;
                // Update the CurrentShellViewPortSize after accounting for AsidePane. This is also used for NavPane.
                shellNewViewport = $dyn.shell._getViewPortSize(shellAvailableCols);
                return shellAvailableCols;
            };
            $dyn.shell._formViewPortSizeChanged = function () {
                // Calculate number of columns can fit into viewportWidth
                var formAvailableCols = Math.floor(formViewportWidth / $dyn.shell.CurrentViewportSizes.viewportWidth);
                formAvailableCols = asidePaneOpen === true ? formAvailableCols - 1 : formAvailableCols;
                formNewViewport = $dyn.shell._getViewPortSize(formAvailableCols);
                return formAvailableCols;
            };
            shellAvailableCols = $dyn.shell._shellViewPortSizeChanged();
            formAvailableCols = $dyn.shell._formViewPortSizeChanged();
            // When pinned, the navpane takes second priority after the aside pane.
            // When not pinned, the navpane will be closed on resize events.
            if ($dyn.value($dyn.shell.isNavigationPanePinned)) {
                if (shellAvailableCols < 2) {
                    // If we are out of room, unpin it.  This will also close it.
                    if (!$dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                        $dyn.shell.toggleIsNavigationPanePinned({ skipSaveValue: true });
                    }
                }
                else {
                    // If we have enough room, reserve a column for the NavPane and recalculate viewport size available to form content
                    formAvailableCols--;
                    formNewViewport = $dyn.shell._getViewPortSize(formAvailableCols);
                }
            }
            // Close navpane flyout if open.
            if ($dyn.shell._navigationPaneIsOpen && !$dyn.value($dyn.shell.isNavigationPanePinned)) {
                $dyn.shell.setNavigationPaneIsOpen(false);
            }
            // Raise the formViewportSizeEvent only when form viewport size has changed.
            if (formNewViewport !== $dyn.shell.CurrentFormViewportSize) {
                $dyn.shell.CurrentFormViewportSize = formNewViewport;
                $(document.body).trigger($dyn.shell.formViewportSizeEvent, formNewViewport);
            }
            // Raise the shellViewportSizeEvent only when shell viewport size has changed.
            if (shellNewViewport !== $dyn.shell.CurrentShellViewPortSize) {
                $dyn.shell.CurrentShellViewPortSize = shellNewViewport;
                $(document.body).trigger($dyn.shell.shellViewportSizeEvent, shellNewViewport);
                if (shellNewViewport === $dyn.shell.ViewportSize.Small) {
                    $dyn.shell.isSmallViewPort(true);
                }
                else {
                    $dyn.shell.isSmallViewPort(false);
                }
            }
            // Raise the actual shellViewPortWidthSizeEvent
            $dyn.shell.CurrentShellViewPortWidthSize = shellViewportWidth;
            // Always rerender the NavPane, we want the flyout to close when we resize the browser even when the viewport does not change.
            if ($dyn.shell._modulesPaneElement) {
                $dyn.shell._renderNavigationPane();
            }
            if ($dyn.util.isZoomSupported()) {
                // set observable that some controls watch for being in zoom size.
                $dyn.util.isInZoomWidthMode() ? $dyn.shell.zoomModeWidth(true) : $dyn.shell.zoomModeWidth(false);
                $dyn.util.isInZoomHeightMode() ? $dyn.shell.zoomModeHeight(true) : $dyn.shell.zoomModeHeight(false);
            }
            $(document.body).trigger($dyn.shell.shellViewportWidthSizeEvent, shellViewportWidth);
        }
        shell.viewportSizeChanged = viewportSizeChanged;
        function isFormRootOfNonFocusableActiveForm(activeFormContext, form) {
            var isRootOfNonFocusableActiveForm = false;
            if (activeFormContext) {
                var focusTarget = activeFormContext.FindFocusTarget ? activeFormContext.FindFocusTarget() : undefined;
                if (!activeFormContext.TakeFocus && focusTarget && focusTarget.length && focusTarget[0]) {
                    var control = $dyn.context(focusTarget[0]);
                    if (control) {
                        isRootOfNonFocusableActiveForm = control.Root === form;
                    }
                }
            }
            return isRootOfNonFocusableActiveForm;
        }
        shell.isFormRootOfNonFocusableActiveForm = isFormRootOfNonFocusableActiveForm;
        /**
         * Check to see the focus transition is valid
         * @internal
         * @param form Form context or a related type that extends form.
         */
        function canFocus(form) {
            if (!form) {
                $dyn.log.focus && $dyn.log.focus("Focus: Shell->canFocus - form is falsy; return false ");
                return false;
            }
            var part = form.Part ? form.Part() : null;
            if (part && !form.TakeFocus) {
                // Don't allow parts contained by non-focusable form hierarchies to take focus.
                $dyn.log.focus && $dyn.log.focus("Focus: $dyn.shell.focus exiting early as the FormPart is in a TakeFocus === false hierarchy");
                return false;
            }
            var canFocus = true;
            var activeFormContext = $dyn.context($dyn.shell.getActiveForm());
            $dyn.log.focus && $dyn.log.focus("Focus: Shell->canFocus - form trying to focus: %s active from: %s ", form.Id, activeFormContext ? activeFormContext.Id : "none");
            // if the shell has the blocking div up we need to block focus transitions
            if ($dyn.shell._shellBlockingCount > 0) {
                $dyn.log.focus && $dyn.log.focus("Focus: Shell->canFocus - blocking div present");
                canFocus = false;
            }
            // if the form attempting to focus is not the active form we need to block the focus transition
            if (!form.isNavigationActiveForm()
                && !$dyn.shell.isFormRootOfEnhancedPreview(activeFormContext, form)
                && !$dyn.shell.isFormRootOfNonFocusableActiveForm(activeFormContext, form)) {
                $dyn.log.focus && $dyn.log.focus("Focus: Shell->canFocus - not active form");
                canFocus = false;
                // this is the case when the users tabs off the 'form' and then wraps to the form behind.
                // it that case set the focus to the active forms first control
                if (activeFormContext) {
                    activeFormContext.focusFirstControl();
                }
            }
            return canFocus;
        }
        shell.canFocus = canFocus;
        /**
         * Check to see if the preview can be opened
         * @internal
         * @param previewHostForm Form context for the preview control.
         */
        function canOpenPreview(previewHostForm) {
            var canOpenPreview = true;
            var openDialog = $dyn.context($dyn.shell.getCurrentDialog());
            if (openDialog && openDialog !== previewHostForm) {
                canOpenPreview = false;
            }
            return canOpenPreview;
        }
        shell.canOpenPreview = canOpenPreview;
        function activateNavBar() {
            var navBarElement = document.getElementById($dyn.shell.NavBarDocumentId);
            if (navBarElement) {
                // Call $dyn.layout.arrange on it initially once, similar to Form_IsActiveChanged. After that, any changes in the layout bindings
                // will trigger a new arrange call.
                $dyn.layout.arrange(navBarElement, true);
            }
        }
        shell.activateNavBar = activateNavBar;
        function setNavigationPaneIsOpen(value) {
            $dyn.shell._navigationPaneIsOpen = value;
            // for Phone there is no need to re-render as the event listners already handled this
            $dyn.shell._renderNavigationPane();
        }
        shell.setNavigationPaneIsOpen = setNavigationPaneIsOpen;
        function toggleIsNavigationPanePinned(options) {
            var modulePanePinnedClass = "modulesPane-isPinned";
            if ($dyn.value($dyn.shell.isNavigationPanePinned)) {
                // close when unpinning
                $dyn.shell._navigationPaneIsOpen = false;
                $dyn.shell.mainPane.classList.remove(modulePanePinnedClass);
            }
            else {
                $dyn.shell.mainPane.classList.add(modulePanePinnedClass);
            }
            if ($dyn.shell.isPhone) {
                $dyn.shell.isNavigationPanePinned(true); // always force true for phone
            }
            else {
                $dyn.shell.isNavigationPanePinned(!$dyn.value($dyn.shell.isNavigationPanePinned));
            }
            $dyn.shell._renderNavigationPane();
            // save pin state
            if (!(options && options.skipSaveValue)) {
                $dyn.DynReact.ModuleStore.saveMenuPaneSettings($dyn.shell._navigationPaneIsOpen);
            }
            $dyn.shell._handleTransitions();
        }
        shell.toggleIsNavigationPanePinned = toggleIsNavigationPanePinned;
        function _handleTransitions() {
            // We need to let layout and other things that depend on the size of the
            // browser update after the pin transition is finished.
            var transitionEndHandler = function (e) {
                if ($(e.target).is(".primaryConductor") && e.originalEvent.propertyName === "left") {
                    $(window).trigger("resize");
                    $(window).off("transitionend", transitionEndHandler);
                }
            };
            $(window).on("transitionend", transitionEndHandler);
        }
        shell._handleTransitions = _handleTransitions;
        function eventIsInNavigationPane(event) {
            var isInPane = false;
            // Value check before looking in the DOM
            if ($dyn.shell._navigationPaneIsOpen || $dyn.value($dyn.shell.isNavigationPanePinned) || $dyn.value($dyn.shell._isWorkspaceNavigationMode)) {
                isInPane = !!(event && event.target && $(event.target).closest(".modulesPane").length);
            }
            return isInPane;
        }
        shell.eventIsInNavigationPane = eventIsInNavigationPane;
        function _renderNavigationPane() {
            if (!$dyn.restrictedNavigation && !$dyn.shell._noNavigationPane && $dyn.shell._modulesPaneElement) {
                // now call react render
                ReactDOM &&
                    ReactDOM.render(React.createElement($dyn.DynReact.UI.ModulesPane, {
                        PaneIsPinned: $dyn.value($dyn.shell.isNavigationPanePinned),
                        ToggleIsPinned: $dyn.shell.toggleIsNavigationPanePinned,
                        paneIsExpanded: $dyn.shell._navigationPaneIsOpen,
                        setIsExpanded: $dyn.shell.setNavigationPaneIsOpen,
                        ViewportSize: $dyn.shell.isPhone || $dyn.shell._isPhoneSize ? $dyn.shell.ViewportSize.Small : $dyn.shell.CurrentShellViewPortSize,
                        navigationModeIsWorkspace: $dyn.value($dyn.shell._isWorkspaceNavigationMode),
                        isPhoneDevice: $dyn.shell.isPhone || $dyn.shell._isPhoneSize,
                    }), $dyn.shell._modulesPaneElement);
            }
        }
        shell._renderNavigationPane = _renderNavigationPane;
        // This function should contain any steps needed to reinitialize a new session within a shell that is not reinitialized.
        function browserInit() {
            $dyn.shell.browserHistory.initialState();
            $dyn.shell.browserHistory.init();
            $dyn.shell.resetAsidePane(true);
            document.addEventListener("mousedown", function () {
                if ($dyn.ui.isInChordMode) {
                    $($dyn.shell.chordNotification).text("").hide();
                    $dyn.ui.isInChordMode = false;
                    $dyn.ui.chordKeysPressed = null;
                }
            }, true);
            $("#mainPane").focusin($dyn.shell.mainPaneFocusHandler);
            // Disable exit confirmation when receive ctrl+f5
            $(document).on("keydown", function (event) {
                if (event.ctrlKey && event.which === 116) {
                    $dyn.flags.confirmExit = false;
                }
                // if the aside pane is open and this is the esc key close the aside pane unless its task recorder and currently recording
                if ($dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.esc }) &&
                    $dyn.shell.isAsidePaneOpen() &&
                    !($dyn.shell.isTaskRecorderOpen() && $dyn.value($dyn.ax.taskRecording.isRecording))) {
                    // Need to verify if the target is not in the Navigation Pane.
                    // jquery and react use conflicting synthetic event systems that prevent relying on standard event handling ordering.
                    if (!(event && $(event.target).closest(".modulesPane").length)) {
                        $dyn.shell.resetAsidePane(false);
                        return;
                    }
                }
                // Set activeFormContext to the root element of the event target, if there is one defined, otherwise to the current active form.
                // Example: If a lookup form is open, the focus stays in the input control so the host form should receive the keydown event for default action.
                var rootElement;
                if ($dyn.context(event.target)) {
                    rootElement = $dyn.context(event.target).Root;
                }
                var activeFormContext = rootElement || $dyn.context($dyn.shell.getActiveForm());
                if (activeFormContext && !$dyn.shell.disableShortcuts && event.target !== document.body) {
                    //  Let the active form handle any keyboard shortcuts it may have registered.
                    activeFormContext.keydown && activeFormContext.keydown(event);
                }
                if (!event.isPropagationStopped()) {
                    $dyn.util.handleShortcuts($dyn.shell, event);
                    // clear isInChordMode if there were no matches
                    if (!event.isPropagationStopped()) {
                        // Don't clear the chords if user has only pressed a modifier key
                        if (event.which !== $dyn.ui.KeyCodes.shift && event.which !== $dyn.ui.KeyCodes.ctrl && event.which !== $dyn.ui.KeyCodes.alt) {
                            if ($dyn.ui.isInChordMode) {
                                var keyCombo = $dyn.util.getTextFromKeysObject($dyn.ui.chordKeysPressed) + ", " + $dyn.util.getTextFromKeydownEvent(event);
                                $($dyn.shell.chordNotification).text($dyn.format($dyn.label("Framework_InvalidKeyCombo"), keyCombo));
                                // TODO: extract the timeout to a constant
                                window.setTimeout(function () {
                                    $($dyn.shell.chordNotification).text("").hide();
                                }, 5000);
                                $dyn.ui.isInChordMode = false;
                                $dyn.ui.chordKeysPressed = null;
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        }
                    }
                }
            });
        }
        shell.browserInit = browserInit;
        function documentTitleInit() {
            // Browser title based on only the top form, no updates to title for other view changes (e.g. edit/grid mode or dialogs).
            $dyn.observe($dyn.shell.primaryForm, function (form) {
                if (form) {
                    $dyn.shell._formCaptionObserver = $dyn.observe(form.FormCaption, function (caption) {
                        if (caption) {
                            $dyn.shell.primaryFormCaption(caption);
                        }
                        else {
                            $dyn.shell.primaryFormCaption($dyn.shell.ProductShortName());
                        }
                    }, null, $dyn.shell._formCaptionObserver);
                }
            });
            $dyn.observe($dyn.options({ caption: $dyn.shell.primaryFormCaption }, $dyn.async.pending), function (options) {
                // Skip updating the title if we will be writing to the browser history (can't change title before adjusting browser history stack)
                if (!$dyn.shell.browserHistory.newStatePending() && !$dyn.shell.browserHistory.waitForPopStateHandler()) {
                    $dyn.shell.setDocumentTitle(options.caption);
                }
            });
        }
        shell.documentTitleInit = documentTitleInit;
        function initializeUser() {
            var userElement = document.getElementById($dyn.shell.UserDocumentId);
            var user = $dyn.context(userElement);
            user.element = userElement;
            // always load the theme from local storage first this is done here to facilitate potential use for popups
            $dyn.densityThemeManager._getCurrentLocalTheme();
            // if special case popoutuser, we need to get the theme and density set
            if ($dyn.shell.UserDocumentId === "PopoutUser") {
                // calling internal helpers
                $dyn.setValue(user, "Density", $dyn.densityThemeManager._previousDensity);
                $dyn.setValue(user, "Theme", $dyn.densityThemeManager._previousTheme);
            }
            $dyn.user(user);
            var companyElement = document.getElementById($dyn.shell.CompanyDocumentId);
            var company = $dyn.context(companyElement);
            $dyn.company(company);
        }
        shell.initializeUser = initializeUser;
        /**
         * Returns true if the UI is blocked due to local or remote processing.
         * @internal
         */
        function isProcessing() {
            return $dyn.shell._shellBlockingCount > 0 || $dyn.async.IsClientProcessing();
        }
        shell.isProcessing = isProcessing;
        function _shellBlockingDivKeydown(evt) {
            $dyn.logError("Keydown event was eaten by the blocking div.");
            $dyn.shell._blockingDivKeystrokeLossCount++;
        }
        shell._shellBlockingDivKeydown = _shellBlockingDivKeydown;
        function blockingDivKeydown(evt) {
            // Swallow all key down events except for F5 (page refreshes) and F12 (dev tools)
            if (!$dyn.util.isShortcutKeyPressed(evt, { ctrl: true, keyCode: $dyn.ui.KeyCodes.f5 }) &&
                !$dyn.util.isShortcutKeyPressed(evt, { ctrl: false, keyCode: $dyn.ui.KeyCodes.f5 }) &&
                !$dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.f12 })) {
                $dyn.shell._shellBlockingDivKeydown(evt);
                $dyn.shell.animateBlockingText(evt);
            }
        }
        shell.blockingDivKeydown = blockingDivKeydown;
        function _addTelemetryForBlockingDivKeyDown() {
            var blockingDivControl = { Name: "BlockingDiv" };
            $dyn.shell._keystrokeLossEventArgs = $dyn.telemetry.addControlActionEvent(blockingDivControl, $dyn.shell._keystrokeLossEventArgs, $dyn.telemetry.ActionEvents.keystrokeLoss, {
                userDefined1: $dyn.shell._blockingDivKeystrokeLossCount,
                extendedData: $dyn.shell._blockingDivDescription,
            });
            $dyn.shell._blockingDivKeystrokeLossCount = 0;
        }
        shell._addTelemetryForBlockingDivKeyDown = _addTelemetryForBlockingDivKeyDown;
        function blockUserInteraction(blockingDivDescription) {
            // Perform the block on a timeout in case a single user action has triggered multiple synchronous
            // commands to be executed. (ie. Clicking a button causes a serversetfocus and a click.)
            // Without a timeout the click event will get blocked because the serversetfocus command brings up the blocking div.
            // For now using a 100ms timeout to ensure the other handlers have time to fire before the blocking div is placed.
            window.setTimeout(function () {
                $dyn.shell._shellBlockingCount++;
                $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Shell->blockUserInteraction - _shellBlockingCount: %d", $dyn.shell._shellBlockingCount);
                $dyn.shell.blockUserInteractionInternal(blockingDivDescription);
            }, 100);
        }
        shell.blockUserInteraction = blockUserInteraction;
        function blockUserInteractionNoWait(blockingDivDescription) {
            $dyn.shell._shellBlockingCount++;
            $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Shell->blockUserInteractionNoWait - _shellBlockingCount: %d", $dyn.shell._shellBlockingCount);
            $dyn.shell.blockUserInteractionInternal(blockingDivDescription);
        }
        shell.blockUserInteractionNoWait = blockUserInteractionNoWait;
        function _blockLeavingWaiting(event) {
            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Shell: blockLeavingWaiting / stopPropagation");
            event.preventDefault();
            event.stopImmediatePropagation();
            $dyn.shell.blockingDiv.focus();
        }
        shell._blockLeavingWaiting = _blockLeavingWaiting;
        function blockUserInteractionInternal(blockingDivDescription) {
            if (blockingDivDescription) {
                $dyn.shell._blockingDivDescription = blockingDivDescription;
            }
            if ($dyn.shell._shellBlockingCount > 0 && $dyn.shell.blockingDiv) {
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startBlockingDiv && $dyn.ui.PerformanceTimer._startBlockingDiv(blockingDivDescription);
                // apply aria-busy
                if (!$dyn.shell._shellBlockingDivAriaBusyElement && $dyn.shell.getActiveForm()) {
                    $dyn.shell._shellBlockingDivAriaBusyElement = $dyn.shell.getActiveForm().parentNode;
                }
                if ($dyn.shell._shellBlockingDivAriaBusyElement) {
                    $dyn.shell._shellBlockingDivAriaBusyElement.setAttribute("aria-busy", "true");
                }
                // block user interaction
                $dyn.shell.blockingDiv.style.display = "";
                $dyn.shell._blockingTextAnimated = false;
                if ($dyn.shell.blockingDiv && $dyn.shell._shellBlockingCount === 1) {
                    var blockingCallback = function () {
                        var form = $dyn.context($dyn.shell.getActiveForm());
                        if (form) {
                            // Call remove focus so we can save off the selection information on the currently focused element.
                            var focusObject = $dyn.ui.removeFocus($(form.element));
                            if (focusObject) {
                                focusObject.formId = form.Id;
                                $dyn.shell.updateFocusableElement(focusObject);
                            }
                        }
                        $dyn.shell.blockingDiv.focus();
                        // Register the list of handlers that are approved to execute while the blocking div is up.
                        $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Shell->blockUserInteractionInternal - force the div to have focus");
                        $dyn.shell.blockingDiv.addEventListener("focusout", $dyn.shell._blockLeavingWaiting);
                    };
                    $dyn.shell.focusCallback(blockingCallback, $dyn.shell, null, { overwrite: true });
                }
                // create timer to show processing text
                if ($dyn.shell._timerHandle === -1) {
                    $dyn.shell._timerHandle = window.setTimeout(function () {
                        // if the timer fired make sure the blocking div is still shown
                        if ($dyn.shell.blockingDiv) {
                            if ($dyn.shell.blockingDiv.style.display !== "none") {
                                if (!$dyn.shell._blockingTextAnimated) {
                                    $dyn.shell.animateBlockingText();
                                }
                            }
                        }
                    }, $dyn.shell.processingTimer);
                }
            }
        }
        shell.blockUserInteractionInternal = blockUserInteractionInternal;
        /**
         * stores the old focussable element so that blocking div can put it back
         * @param focusObject Contains the form id, element to put focus, element selection start, element selection end
         */
        function updateFocusableElement(focusObject) {
            $dyn.shell._oldFocusedControlOptions = focusObject;
            if ($dyn.shell._oldFocusedControlOptions) {
                $dyn.shell._oldFocusedControlOptions.formId = focusObject.formId;
                var $controlElement = $($dyn.shell._oldFocusedControlOptions.element).closest("[data-dyn-controlname]");
                $dyn.shell._oldFocusedControlOptions.controlName = $controlElement.length ? $controlElement[0].getAttribute("data-dyn-controlname") : "";
            }
        }
        shell.updateFocusableElement = updateFocusableElement;
        function unBlockUserInteractionInternal() {
            $dyn.shell._blockingTextAnimated = false;
            $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Shell->unBlockUserInteraction - remove div and reset focus");
            if ($dyn.shell._shellProcessingDiv) {
                $dyn.shell._shellProcessingDiv.style.display = "none";
                $dyn.shell._shellProcessingDiv.classList.remove("statusBarIn");
            }
            if ($dyn.shell.blockingDiv) {
                $dyn.shell.blockingDiv.removeEventListener("focusout", $dyn.shell._blockLeavingWaiting);
                $dyn.shell.blockingDiv.style.display = "none";
            }
            // the blocking div could have taken focus
            // restore focus
            if (!$dyn.shell.isShellInitializing()) {
                var unblockingCallback = function () {
                    var form = $dyn.context($dyn.shell.getActiveForm());
                    if (form) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->unBlockUserInteraction return focus form Id: %s calling takeNavigationFocus", form.Id);
                        form.takeNavigationFocus();
                        // Focus is done in a microtask within takeNavigationFocus, restore the selection after that is completed
                        $dyn.microTask(function () {
                            if ($dyn.shell._oldFocusedControlOptions &&
                                $dyn.shell._oldFocusedControlOptions.formId === form.Id &&
                                $dyn.shell._oldFocusedControlOptions.controlName === $dyn.value(form.ActiveControl) &&
                                document.activeElement &&
                                document.activeElement.value) {
                                // Only restore the seletion if the focused element before the blocking div went up is the
                                // same element focused after the blocking div is hidden. (Same form, same control)
                                $dyn.ui.selectionStart(document.activeElement, $dyn.shell._oldFocusedControlOptions.selectionStart);
                                $dyn.ui.selectionEnd(document.activeElement, $dyn.shell._oldFocusedControlOptions.selectionEnd);
                            }
                            $dyn.shell._oldFocusedControlOptions = null;
                        });
                    }
                };
                $dyn.shell.focusCallback(unblockingCallback, $dyn.shell, null, { overwrite: true });
            }
            window.clearTimeout($dyn.shell._timerHandle);
            $dyn.shell._timerHandle = -1;
            // Log telemetry for keystrokes lost against the blocking div
            if ($dyn.shell._blockingDivKeystrokeLossCount > 0) {
                $dyn.shell._addTelemetryForBlockingDivKeyDown();
            }
            // apply aria-busy to false
            if ($dyn.shell._shellBlockingDivAriaBusyElement) {
                $dyn.shell._shellBlockingDivAriaBusyElement.setAttribute("aria-busy", "false");
            }
            $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopBlockingDiv && $dyn.ui.PerformanceTimer._stopBlockingDiv();
        }
        shell.unBlockUserInteractionInternal = unBlockUserInteractionInternal;
        function unBlockUserInteraction() {
            if ($dyn.shell._shellBlockingCount === 0) {
                $dyn.logError("Attempted to decrement the shell blocking count below 0.");
            }
            else {
                $dyn.shell._shellBlockingCount--;
                $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Shell->unBlockUserInteraction - _shellBlockingCount: %d", $dyn.shell._shellBlockingCount);
            }
            if ($dyn.shell._shellBlockingCount === 0) {
                $dyn.shell.unBlockUserInteractionInternal();
            }
        }
        shell.unBlockUserInteraction = unBlockUserInteraction;
        function forceUnBlockUserInteraction() {
            $dyn.logError("Resetting the shell blocking count to 0.");
            $dyn.shell._shellBlockingCount = 0;
            $dyn.serverForm && $dyn.serverForm.interactionManager.resetGlobalBlockingFlag();
            $dyn.shell.unBlockUserInteractionInternal();
        }
        shell.forceUnBlockUserInteraction = forceUnBlockUserInteraction;
        function focusCallback(callback, thisArg, focusElement, options) {
            if ($dyn.shell.isActiveWindow()) {
                $dyn.callFunction(callback, thisArg, [focusElement]);
            }
            else {
                // Save the callback to be executed when the window receives focus again
                // Either overwrite the singleton callback or add it to a queue of focus callbacks
                if (options.overwrite) {
                    $dyn.log.focus && $dyn.log.focus("Focus: overwritten focus callback was set up");
                    $dyn.shell.overwrittenFocusCallback = {
                        callback: callback,
                        context: thisArg,
                        focusElement: focusElement,
                    };
                }
                else if (options.queue) {
                    $dyn.log.focus && $dyn.log.focus("Focus: control focus callback was added to the queue");
                    $dyn.shell.queuedFocusCallbacks.push({ callback: callback, context: thisArg, focusElement: focusElement });
                }
            }
        }
        shell.focusCallback = focusCallback;
        function animateBlockingText(evt) {
            if (evt) {
                evt.stopImmediatePropagation();
                evt.preventDefault();
            }
            if (!$dyn.shell._blockingTextAnimated && $dyn.shell.hideSplash && $dyn.shell._shellProcessingDiv) {
                $dyn.shell._shellProcessingDiv.style.display = "";
                $dyn.shell._shellProcessingDiv.classList.add("statusBarIn");
                $dyn.shell._blockingTextAnimated = true;
            }
        }
        shell.animateBlockingText = animateBlockingText;
        function initialForm() {
            var options = $dyn.shell.defaultForm;
            if ($dyn.flags.enableResources) {
                var query = $dyn.util.location.query;
                if (query.resource) {
                    var validPattern = /^[a-z_][a-z0-9_]*$/i;
                    if (validPattern.test(query.resource)) {
                        options = {
                            resource: ($dyn.url(query.resource) + ".htm").toLowerCase(),
                            templateId: query.resource.toLowerCase(),
                        };
                    }
                }
            }
            return options;
        }
        shell.initialForm = initialForm;
        /**
         * The form will be added to the proper area and .Open called on the form.
         * @internal
         * @param options Describes the form that should be opened.
         */
        function open(options) {
            var form = options.form;
            if (form === undefined) {
                $dyn.log.navigation && $dyn.log.navigation("shell.open() -> no form");
                return;
            }
            var displayTarget = $dyn.value(form.DisplayTarget);
            var type = form.TypeName;
            if (displayTarget === $dyn.forms.DisplayTarget.Hidden) {
                // No need to do anything since the form is to remain hidden
                form._openedDisplayTarget = $dyn.forms.DisplayTarget.Hidden;
            }
            else {
                switch (type) {
                    case "Dialog":
                    case "LightBox":
                        if (displayTarget === $dyn.forms.DisplayTarget.AsidePane) {
                            // In the future we may want to set this more conditionally from the server
                            form.shouldDisplayHelpIcon(false);
                            $dyn.shell.showAside({ targetElement: form.element });
                            form._openedDisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                        }
                        else {
                            $dyn.shell.dialog({ typeName: type, targetElement: form.element });
                        }
                        break;
                    case "Form":
                        $dyn.shell.navigate({ targetElement: form.element });
                        break;
                    case "Popup":
                    case "DropDialogPopup":
                    case "PartForm":
                    case "FactBoxForm":
                        break;
                    default:
                        $dyn.log.navigation && $dyn.log.navigation("shell.open() -> unknown form type: " + type);
                        break;
                }
                if (form.Open) {
                    form.Open();
                }
            }
        }
        shell.open = open;
        /**
         * The form will be
         *      - removed from the proper area
         *      - shell state cleaned up
         *      - ReadyState will be set to closed
         *      - ._close called on the form
         * @internal
         * @param options Describes the form that should be closed.
         */
        function close(options) {
            var form = options.form;
            if (form === undefined) {
                $dyn.log.navigation && $dyn.log.navigation("shell.close() -> no form");
                return;
            }
            $dyn.log.navigation && $dyn.log.navigation("Navigation: shell.close: " + form._formName);
            var type = form.TypeName;
            // close any whatsnewDialogs for this form
            $dyn.whatsNew.closeTipsForForm(form._formName);
            if (form._openedDisplayTarget === $dyn.forms.DisplayTarget.Hidden) {
                $dyn.shell._removeForm(form.element);
            }
            else {
                switch (type) {
                    case "Dialog":
                    case "LightBox":
                        form.onClose.raise();
                        if (form._openedDisplayTarget === $dyn.forms.DisplayTarget.AsidePane) {
                            $dyn.shell.removeFromAside({ targetElement: form.element });
                        }
                        else {
                            $dyn.shell.previewManager.removePreview();
                            // Don't clean up flyouts if this is a lightbox
                            // TODO make type guard?
                            if (!form.IsLightBox) {
                                $dyn.flyout.flyoutManager.removeAllFlyoutsAsync();
                            }
                            $dyn.shell.activeMessageBox = undefined;
                            var closed_1 = $dyn.shell.dialogBack({ element: form.element });
                            if (closed_1) {
                                form.IsOpen(false);
                            }
                        }
                        break;
                    case "Form":
                        // Raise the onClose event so nested controls can complete logic before finishing the closing of the host form
                        form.onClose.raise();
                        $dyn.shell.previewManager.removePreview();
                        $dyn.flyout.flyoutManager.removeAllFlyoutsAsync();
                        $dyn.shell.removePrimaryForm({ targetElement: form.element });
                        break;
                    case "PartForm":
                    case "FactBoxForm":
                        $dyn.shell.previewManager.removePreview();
                        $dyn.flyout.flyoutManager.removeAllFlyoutsAsync();
                        $dyn.shell._removeForm(form.element);
                        break;
                    case "Popup":
                    case "DropDialogPopup":
                        // Raise the onClose event so nested controls can complete logic before finishing the closing of the host form
                        form.onClose.raise();
                        $dyn.shell.previewManager.removePreview();
                        // When closing a popup form we should only attempt to remove the flyout associated with that popup. We don't want to close all open flyouts
                        // (or even the top level flyout) as it can have unintentional consequences. For example, if one attempts to open a lookup directly while another
                        // lookup is open, we only want to close the first lookup. See bug 3727830.
                        // Is closing just the flyout associated with this popup sufficient? The answer so far seems to be yes but will need to monitor.
                        $dyn.flyout.flyoutManager.removeFlyoutByElementId(form.element.id);
                        $dyn.getFunction(form.element.dynClose)();
                        $dyn.shell._removeForm(form.element);
                        break;
                    default:
                        $dyn.log.navigation && $dyn.log.navigation("shell.close() -> unknown form type: " + type);
                        break;
                }
                if (form.element && form.element.dynReadyState) {
                    form.element.dynReadyState($dyn.ui.ReadyState.closed);
                }
                if (form._close) {
                    form._close();
                }
            }
        }
        shell.close = close;
        /**
         * Manages displaying a new dialog
         * @internal
         * @param options Describes the form
         */
        function dialog(options) {
            var navigationStack;
            var activeForm = $dyn.shell.getCurrentRootForm() && $dyn.context($dyn.shell.getCurrentRootForm());
            var applicationModal = options.role === "Dialog" || options.typeName === "LightBox";
            if (!activeForm) {
                // Opening a slider when we have no primary form.  (Via menu item parameter or the navigation pane.)
                activeForm = $dyn.shell.getPlaceholderForm();
                $dyn.shell.navigate({ targetElement: activeForm.element });
            }
            if (applicationModal) {
                navigationStack = $dyn.shell.dialogStack;
            }
            else {
                navigationStack = activeForm.dialogStack;
            }
            var dialogStackLength = $dyn.length(navigationStack);
            var navigationStackTopDialog = navigationStack()[dialogStackLength - 1];
            if (navigationStackTopDialog !== options.targetElement) {
                // Do not hide a dialog when dialog is already open
                $dyn.shell.deactivateElement(navigationStackTopDialog, { doNotHide: true });
            }
            $dyn.context(options.targetElement).canGoBack(options.canGoBack || $dyn.length(navigationStack) > 0);
            if (options.back !== undefined) {
                $dyn.context(options.targetElement).back = options.back;
            }
            // Make sure we display the correct context for any error messages
            if ($dyn.shell.isClosingOpenForms) {
                // attempt to get the top form to hide the dialog
                var element = $dyn.value($dyn.shell.stack)[$dyn.shell.closingAllIndex + 1];
                // unblocked unsupported pattern in x++ - class opens a form then calls wait and askes the user to use the company picker
                // in this case the shell is trying to close all, but the form is waiting and not closed yet and the index is off until
                // the shell closes the forms and the form wait completes check for undefined so we don’t get an exception
                // this is an unsupported pattern bug 3829947 and 3829868
                if (element) {
                    var stackLength = $dyn.length($dyn.context(element).dialogStack);
                    element.style.display = "";
                    if (stackLength) {
                        $dyn.value($dyn.context(element).dialogStack)[stackLength - 1].style.display = "";
                    }
                }
            }
            // Dialog gets displayed in the main pane
            $dyn.shell.mainPane.appendChild(options.targetElement);
            navigationStack.push(options.targetElement);
            var activateElementFunc = function () {
                $dyn.shell.activateElement(options.targetElement, { forceActivation: applicationModal });
                if ($dyn.shell._placeholderForm && activeForm === $dyn.shell._placeholderForm && !shell.activeFormObserver) {
                    shell.activeFormObserver = $dyn.observe($dyn.activeForm, function (newValue) {
                        if (!$dyn.shell._placeholderForm) {
                            shell.activeFormObserver = undefined;
                            return false;
                        }
                        if (newValue === $dyn.shell._placeholderForm.element) {
                            // closing top primary form should open default start page
                            $dyn.shell.close({ form: $dyn.shell._placeholderForm });
                            shell.activeFormObserver = undefined;
                            return false;
                        }
                    });
                }
            };
            if (activeForm && activeForm.PendingGrid && activeForm.PendingGrid.syncManager && !$dyn.value($dyn.clientInError)) {
                activeForm.PendingGrid.syncManager.setResumeCallback(function () {
                    activateElementFunc();
                    var dialogContext = $dyn.context(options.targetElement);
                    if (dialogContext && dialogContext.onClose) {
                        var dialogCloseSubscriptionId_1 = dialogContext.onClose.subscribe(function () {
                            if (activeForm && activeForm.PendingGrid && activeForm.PendingGrid.syncManager) {
                                activeForm.PendingGrid.syncManager.resumeCallbackComplete();
                            }
                            dialogContext.onClose.unsubscribe(dialogCloseSubscriptionId_1);
                        });
                    }
                });
            }
            else {
                activateElementFunc();
            }
            // Stop propagation of clicks and key strokes to underlying forms for application modal dialogs
            if (applicationModal) {
                var stopPropagation_1 = function (event) {
                    if ($dyn.debug.verboseStopPropagation) {
                        $dyn.log("shell.dialog() -> MessageBox stopPropagation");
                    }
                    event.stopImmediatePropagation();
                };
                var keyboardHandler = function (event) {
                    if (options.targetElement.contains(event.target)) {
                        var formContext = $dyn.context(options.targetElement);
                        if (formContext && formContext.keydown) {
                            formContext.keydown(event);
                        }
                    }
                    stopPropagation_1(event);
                };
                if (options.typeName === "LightBox") {
                    $(options.targetElement)
                        .find(".titleField")
                        .attr("id", "titleField");
                }
                $(options.targetElement)
                    .find(".popupShadow")
                    .on("click", stopPropagation_1);
                $(options.targetElement)
                    .find(".popupShadow")
                    .on("keydown", keyboardHandler);
            }
            if (options.targetElement.dynReadyState() === $dyn.ui.ReadyState.uninitialized) {
                options.targetElement.dynReadyState($dyn.ui.ReadyState.ready);
            }
            if (!applicationModal && activeForm) {
                // Only reset if the form is not application modal. This is so we don't close forms unintentionally.
                // Example: a lightbox launched from a dropdialog should not close it's parent dropdialog when it opens.
                $dyn.shell.resetShellOnNavigation();
            }
        }
        shell.dialog = dialog;
        /**
         * Manages displaying a form in the asidePane
         * @description Private method for the shell to manage aside pane content
         * Shows a form or a dialog in the aside pane of the shell
         * The aside pane is outside the primary form, and does not block interactions with the primary form or the navigation bar.
         * "Closing" the aside pane does not close the control, it only changes visibility
         * Showing a new control will hide (but not close) any control currently visible in the aside pane.
         * The current implementation relies on the controls to manage their state.  Future refactoring should update the shell to track what controls
         *     are open and could be shown in the aside pane to allow the user to toggle between which control is visible.
         * Form level shortcuts are not supported for the aside pane, shortcut keys will be directed to the primary form.
         * Forms visible in the aside pane are considered active even though they are not registered as the shell's active form.
         * Aside pane maintains a stack of all forms showed unless they are removed from the stack by calling removeFromAside
         * Showing a form always makes it the top of the stack
         * @private
         * @param options Describes the form
         */
        function showAside(options) {
            if (options.targetElement) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Opening form in the aside pane.");
                var element_1 = options.targetElement;
                if (!$dyn.shell._asidePane) {
                    // Find the main pane on the shell, and if none found, use the body tag
                    $dyn.shell._asidePane = $("#asidePane")[0] || document.body;
                    $dyn.dataBind($dyn.shell._asidePane);
                    if ($dyn.shell._asidePane.getElementsByClassName("ui-resizable-handle")[0]) {
                        $dyn.shell._asidePaneResizeHandle = $dyn.shell._asidePane.getElementsByClassName("ui-resizable-handle")[0];
                    }
                }
                else {
                    if ($dyn.shell._asidePaneResizeHandle && !$dyn.value($dyn.shell.isSmallViewPort)) {
                        $dyn.shell._asidePaneResizeHandle.style.display = "block";
                    }
                }
                // make sure the class is set and the resizer is visible
                $dyn.shell._asidePane.classList.add("expanded");
                // set the width if previously resized
                $dyn.shell._asidePane.style.width = !$dyn.value($dyn.shell.isSmallViewPort) && $dyn.value($dyn.shell.asidePaneWidth) !== "" ? $dyn.value($dyn.shell.asidePaneWidth) : null;
                if ($dyn.shell._asidePaneCurrentContent !== element_1) {
                    // Hide the previous tenant, if displayed
                    // Note: the top-of-the-stack form may still not be displayed if the pane
                    // has been closed by the user
                    // note resizer is first child so skip
                    if ($dyn.shell._asidePane.children.length > 1) {
                        $dyn.context($dyn.shell._asidePane.children[1]).onHide(null);
                        $dyn.shell._asidePane.removeChild($dyn.shell._asidePane.children[1]);
                        $dyn.shell._asidePaneCurrentContent = null;
                    }
                    // Make new form as the top element on the stack
                    var index = $dyn.peek($dyn.shell._asidePaneStack).lastIndexOf(element_1);
                    if (index >= 0 && index < $dyn.shell._asidePaneStack.len - 1) {
                        // It existed from before.
                        // Remove from previous position, we will add to the end to be the top
                        $dyn.shell._asidePaneStack.splice(index, 1);
                    }
                    // Add to the top
                    $dyn.shell._asidePaneStack.push(element_1);
                    // Content is hideable in aside pane
                    // Provide the hide handler
                    // There is no way currently to unhide the pane with its current top-of-stack form
                    var contentContext = $dyn.context(element_1);
                    if (contentContext.onHide === undefined) {
                        contentContext.onHide = $dyn.observable();
                    }
                    contentContext.onHide(function () {
                        $dyn.shell.hideAsidePane(element_1);
                    });
                    // Attach content
                    $dyn.shell._asidePane.appendChild(element_1);
                    $dyn.shell._asidePaneCurrentContent = element_1;
                    // Activate content
                    contentContext.IsActive(true);
                    element_1.style.display = "";
                    $dyn.applyFunction(contentContext.takeNavigationFocus, contentContext);
                    // Update state
                    if (element_1.dynReadyState() !== $dyn.ui.ReadyState.aborted &&
                        (element_1.dynReadyState() === $dyn.ui.ReadyState.uninitialized || element_1.dynReadyState() === $dyn.ui.ReadyState.loading)) {
                        element_1.dynReadyState($dyn.ui.ReadyState.ready);
                    }
                    // At this point aside pane is open
                    $dyn.shell.isAsidePaneOpen(true);
                }
            }
        }
        shell.showAside = showAside;
        /**
         * Removes a form from the aside pane. If the aside pane is currently open, this shows the
         * next in stack from or otherwise closes the aside pane if there is nothing to display
         * @private
         * @param options Describes the form to be removed from the asidePane.
         */
        function removeFromAside(options) {
            if (options && options.targetElement) {
                var element = options.targetElement;
                // Is it the content currently being displayed?
                if ($dyn.shell._asidePaneCurrentContent === element) {
                    var currentStack = $dyn.peek($dyn.shell._asidePaneStack);
                    // Do we have something else in the stack that we could should in place of this?
                    if (currentStack.length > 1) {
                        // Show the next form in the stack - that will make sure this becomes non-top
                        $dyn.shell.showAside({ targetElement: currentStack[currentStack.length - 2] });
                    }
                    else {
                        // This is the only one, close it
                        $dyn.context(element).onHide(null);
                        $dyn.shell._asidePane.removeChild(element);
                        $dyn.shell._asidePaneCurrentContent = null;
                        // Aside pane is now closed
                        $dyn.shell.isAsidePaneOpen(false);
                    }
                }
                // Remove the form from the stack if it exists
                var index = $dyn.peek($dyn.shell._asidePaneStack).lastIndexOf(element);
                if (index >= 0) {
                    // Remove it from the stack
                    $dyn.shell._asidePaneStack.splice(index, 1);
                }
                // Dispose the form
                $dyn.shell._removeForm(element);
            }
        }
        shell.removeFromAside = removeFromAside;
        /**
         * Gets the form that is currently active in the aside pane
         * @internal
         * @returns form DOM element
         */
        function getActiveAsideForm() {
            var asidePaneStack = $dyn.value($dyn.shell._asidePaneStack);
            if (asidePaneStack.length > 0) {
                var newTopForm = asidePaneStack[asidePaneStack.length - 1];
                return newTopForm;
            }
            return null;
        }
        shell.getActiveAsideForm = getActiveAsideForm;
        /**
         * Hides the aside pane if it is currently displayed. This is equivalent to clicking the X button.
         * @internal
         * @param optionalIfTopFormElement The operation is only performed if this is the top form in aside pane
         * @param skipCleanup Skips the cleanup of unpinned forms in aside pane if true
         */
        function hideAsidePane(optionalIfTopFormElement, skipCleanup) {
            if ($dyn.peek($dyn.shell.isAsidePaneOpen)) {
                if (optionalIfTopFormElement != null && optionalIfTopFormElement !== $dyn.shell._asidePaneCurrentContent) {
                    return;
                }
                var element = $dyn.shell._asidePaneCurrentContent;
                if (element) {
                    $dyn.context(element).onHide(null);
                    $dyn.shell._asidePane.removeChild(element);
                    $dyn.shell._asidePaneCurrentContent = null;
                }
                $dyn.shell.isAsidePaneOpen(false);
                // Clear the stack
                $dyn.shell._clearAsidePaneStack(skipCleanup);
                // save the width if set then it was resized and clear expand settings
                if ($dyn.shell._asidePane) {
                    $dyn.shell._asidePane.classList.remove("expanded");
                    if ($dyn.shell._asidePaneResizeHandle) {
                        $dyn.shell._asidePaneResizeHandle.style.display = "none";
                    }
                    if ($dyn.shell._asidePane.style.width !== "") {
                        $dyn.shell.asidePaneWidth($dyn.shell._asidePane.style.width);
                        // clear out the width and left
                        $dyn.shell._asidePane.style.width = "";
                        $dyn.shell._asidePane.style.left = "";
                    }
                }
            }
        }
        shell.hideAsidePane = hideAsidePane;
        /**
         * Resets aside pane on shell cleanup. Clears the form stack it holds.
         * @internal
         */
        function resetAsidePane(skipCleanup) {
            $dyn.shell.hideAsidePane(null, skipCleanup);
        }
        shell.resetAsidePane = resetAsidePane;
        /**
         * Reports if the provided event targeted the aside pane.
         * @internal
         */
        function eventInAsidePane(event) {
            return $dyn.value($dyn.shell.isAsidePaneOpen) && event && event.target && $(event.target).closest("#asidePane").length;
        }
        shell.eventInAsidePane = eventInAsidePane;
        /**
         * Clears the aside pane stack and closes any unpinned form in it
         * @private
         * @param skipCleanup Skips the cleanup of unpinned forms in aside pane if true
         */
        function _clearAsidePaneStack(skipCleanup) {
            if (!skipCleanup) {
                var currentStack = $dyn.peek($dyn.shell._asidePaneStack);
                var removalStack = void 0;
                // Traverse in reverse order and build the new stack with only pinned forms left
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < currentStack.length; i++) {
                    var itemContext = $dyn.context(currentStack[i]);
                    // We cannot close it if it prevented from automatic closing, or it is the current content
                    if ((!itemContext || !$dyn.peek(itemContext.PreventAutoClose)) && currentStack[i] !== $dyn.shell._asidePaneCurrentContent) {
                        if (!removalStack) {
                            removalStack = [];
                        }
                        removalStack.push(currentStack[i]);
                    }
                }
                if (removalStack) {
                    // Call close on forms in removal stack
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < removalStack.length; i++) {
                        var formContext = $dyn.context(removalStack[i]);
                        if (formContext && formContext.Close) {
                            $dyn.applyFunction(formContext.Close);
                        }
                    }
                }
            }
            // Clear the stack
            $dyn.shell._asidePaneStack._current = [];
        }
        shell._clearAsidePaneStack = _clearAsidePaneStack;
        function subscribeAsidePaneToggle() {
            return $dyn.observe($dyn.shell.isAsidePaneOpen, function (asidePaneOpen) {
                if (asidePaneOpen) {
                    $dyn.shell.mainPane.classList.add("asidePane-opened");
                    $dyn.shell._asidePane.setAttribute("aria-hidden", "false");
                    $dyn.shell._asidePane.style.display = "block";
                }
                else {
                    $dyn.shell.mainPane.classList.remove("asidePane-opened");
                    $dyn.shell._asidePane.setAttribute("aria-hidden", "true");
                    $dyn.shell._asidePane.style.display = "none";
                }
                // Recalculate viewport size
                $dyn.shell.viewportSizeChanged(asidePaneOpen);
                // Layout arrange should rearrange the main form after aside pane show/hide
                $dyn.layout.reflowRootForm();
                $dyn.shell.reflowShell();
            }, $dyn.shell, null, true);
        }
        shell.subscribeAsidePaneToggle = subscribeAsidePaneToggle;
        function _asidePaneStartResize(event, ui) {
            var newPaneSize = $dyn.shell._returnAsidePaneCalculatedSize(ui);
            // tslint:disable-next-line:triple-equals
            if (newPaneSize != ui.size.width) {
                event.target.style.width = newPaneSize + "px";
            }
            $dyn.shell.asidePaneWidth(newPaneSize);
        }
        shell._asidePaneStartResize = _asidePaneStartResize;
        function _asidePaneStopResize(event, ui) {
            var newPaneSize = $dyn.shell._returnAsidePaneCalculatedSize(ui);
            // tslint:disable-next-line:triple-equals
            if (newPaneSize != ui.size.width) {
                event.target.style.width = newPaneSize + "px";
            }
            $dyn.shell.asidePaneWidth(newPaneSize);
        }
        shell._asidePaneStopResize = _asidePaneStopResize;
        function _returnAsidePaneCalculatedSize(ui) {
            var newPaneSize = ui.size.width;
            if (ui.size.width < $dyn.shell.CurrentViewportSizes.viewportWidth) {
                newPaneSize = $dyn.shell.CurrentViewportSizes.viewportWidth;
            }
            else if (ui.size.width > $dyn.shell.CurrentViewportSizes.viewportWidth * 2) {
                newPaneSize = $dyn.shell.CurrentViewportSizes.viewportWidth * 2;
            }
            return newPaneSize;
        }
        shell._returnAsidePaneCalculatedSize = _returnAsidePaneCalculatedSize;
        function isTaskRecorderOpen() {
            return $dyn.shell.isAsidePaneOpen() && $dyn.shell.isTaskRecorder($dyn.shell.getActiveAsideForm());
        }
        shell.isTaskRecorderOpen = isTaskRecorderOpen;
        function isTaskRecorder(element) {
            return element && element.getAttribute("data-dyn-form-name") === "TaskRecorderPane";
        }
        shell.isTaskRecorder = isTaskRecorder;
        function isTaskRecorderGuideOpen() {
            return $dyn.shell.isAsidePaneOpen() && $dyn.shell.isTaskRecorderGuide($dyn.shell.getActiveAsideForm());
        }
        shell.isTaskRecorderGuideOpen = isTaskRecorderGuideOpen;
        function isTaskRecorderGuide(element) {
            return element && element.getAttribute("data-dyn-form-name") === "SysTaskGuidePane";
        }
        shell.isTaskRecorderGuide = isTaskRecorderGuide;
        function reflowShell() {
            $dyn.shell.shellReflowEvent().raise();
        }
        shell.reflowShell = reflowShell;
        function shellReflowEvent() {
            if (!$dyn.shell._shellReflowEvent) {
                $dyn.shell._shellReflowEvent = new $dyn.eventHost();
            }
            return $dyn.shell._shellReflowEvent;
        }
        shell.shellReflowEvent = shellReflowEvent;
        function loadInitialForm() {
            if ($dyn.serverForm) {
                var options_1 = $dyn.serverForm.initialForm();
                if (options_1.menuItem) {
                    $dyn.telemetry.addNavigationEvent("url", options_1.menuItem, ["menuItem"]);
                }
                else if (options_1.name) {
                    $dyn.telemetry.addNavigationEvent("url", options_1.name, ["formName"]);
                }
                $dyn.shell.createForm(options_1);
                $dyn.shell.clientInitialFormRequested(true);
            }
        }
        shell.loadInitialForm = loadInitialForm;
        function createForm(options) {
            var targetElement;
            if (!options.targetElement) {
                if (options.role === "Dialog") {
                    targetElement = document.createElement("div");
                }
                else {
                    targetElement = document.createElement("form");
                }
                options.targetElement = targetElement;
            }
            else {
                targetElement = options.targetElement;
            }
            if (options.name) {
                // This attribute should be used exclusively for form name (not menu item name).
                targetElement.setAttribute("data-dyn-form-name", options.name);
            }
            var id = ($dyn.shell._nextId++).toString();
            targetElement.setAttribute("data-dyn-clientId", id);
            targetElement.dynOptions = options.parameters;
            if (options.id) {
                targetElement.setAttribute("id", "form_" + options.id);
                targetElement.setAttribute("data-dyn-formid", options.id.toString());
            }
            else {
                targetElement.setAttribute("id", "form_" + id);
                targetElement.setAttribute("data-dyn-formid", id);
            }
            if (options.role) {
                targetElement.setAttribute("data-dyn-role", options.role);
            }
            else {
                options.role = targetElement.getAttribute("data-dyn-role");
            }
            targetElement.dynReadyState = $dyn.observable($dyn.ui.ReadyState.uninitialized);
            // Represents a hybrid array/dictionary
            var perf = (targetElement.dynPerformance = []);
            perf.navigationStart = performance.now();
            targetElement.style.display = "none";
            // Check if you have a parent node. If yes append to that node, else append to the body so that it can be moved later on when the navigate happens
            if (!targetElement.parentNode) {
                if (options.parentNode) {
                    var parent_1 = options.parentNode;
                    parent_1.appendChild(targetElement);
                }
                else {
                    document.body.appendChild(targetElement);
                }
            }
            var context;
            if (options.context) {
                context = options.context;
            }
            else if ($dyn.serverForm) {
                context = options.context = $dyn.serverForm.getModel(id);
            }
            $dyn.callFunction(options.elementCreated, null, options);
            if (options.templateId || options.resource) {
                options.templateId = options.templateId || options.resource;
                var templateExpression = { templateId: options.templateId, resource: options.resource };
                // Remove the starting and ending braces
                targetElement.setAttribute("data-dyn-template", JSON.stringify(templateExpression).slice(1, -1));
                // Support client side Parameters
                if (options.Parameters) {
                    context.Parameters = options.Parameters;
                }
                $dyn.loadTemplateInstance(templateExpression, function templatedLoaded(templateInstance) {
                    targetElement.removeAttribute($dyn.Const.templateApplied);
                    if (targetElement.getAttribute("data-dyn-role")) {
                        $dyn.dataBind(targetElement, new $dyn.DataContext(context, options.parentContext));
                        $dyn.applyFunction(options.dataBound);
                    }
                }, targetElement);
            }
            else if (options.role) {
                // If the role is not set that it is expect that we will eventually have a role set.
                // The code that sets this role is responsible for data binding
                $dyn.dataBind(targetElement, new $dyn.DataContext(context, options.parentContext));
            }
            if (options.updateQuery) {
                $dyn.shell.browserHistory.updateQuery = true;
                $dyn.shell.browserHistory.queryMI = options.menuItem;
            }
            var formContext = $dyn.context(targetElement);
            if (formContext && formContext.OnClientFormLoaded) {
                // call a function on the form signaling the loading on the client completed
                formContext.OnClientFormLoaded();
            }
            return targetElement;
        }
        shell.createForm = createForm;
        function setActiveForm(targetElement) {
            $dyn.log.focus && $dyn.log.focus("Focus: Shell->setActiveForm Form(Form.Id: %s)->InternalFocusIn", targetElement.getAttribute("data-dyn-formid"));
            if (targetElement && $dyn.shell.activeFormElement !== targetElement) {
                if ($dyn.shell.activeFormElement) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->setActiveForm - remove as active form Id: %s", $dyn.shell.activeFormElement.getAttribute("data-dyn-formid"));
                    $dyn.shell.activeFormElement.classList.remove("active-form");
                    // also add aria-hidden false
                    $dyn.shell.activeFormElement.setAttribute("aria-hidden", "true");
                }
                $dyn.shell.activeFormElement = targetElement;
                targetElement.style.display = "";
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Set active form: %s", targetElement.getAttribute("data-dyn-form-name"));
                // if focus is being returned to a part make sure the host form is set as active instead
                var role_1 = $dyn.shell.activeFormElement.getAttribute("data-dyn-role");
                if (role_1 === "PartForm" || role_1 === "FactBoxForm") {
                    var part = $dyn.context($dyn.shell.activeFormElement);
                    if (part && part.Part() && part.Part().Root) {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->setActiveForm - set as active part parent form Id: %s", part.Part().Root.element.getAttribute("data-dyn-formid"));
                        $dyn.shell.activeFormElement = part.Part().Root.element;
                    }
                }
                $dyn.log.focus && $dyn.log.focus("Focus: Shell->setActiveForm - set as active form Id: %s", $dyn.shell.activeFormElement.getAttribute("data-dyn-formid"));
                $dyn.shell.activeFormElement.classList.add("active-form");
                // also add aria-hidden false
                $dyn.shell.activeFormElement.setAttribute("aria-hidden", "false");
                $dyn.activeForm($dyn.shell.activeFormElement);
                if (!$dyn.restrictedNavigation && $dyn.ui.getNavBar() && $dyn.ui.getNavBar().IsFormPersonalizable
                    && $dyn.context($dyn.shell.activeFormElement)) {
                    $dyn.ui.getNavBar().IsFormPersonalizable($dyn.value($dyn.context($dyn.shell.activeFormElement).AllowExplicitPersonalization));
                }
            }
        }
        shell.setActiveForm = setActiveForm;
        function navigationCompleteEvent() {
            if (!$dyn.shell._navigationCompleteEvent) {
                $dyn.shell._navigationCompleteEvent = new $dyn.eventHost();
            }
            return $dyn.shell._navigationCompleteEvent;
        }
        shell.navigationCompleteEvent = navigationCompleteEvent;
        function subscribeToNavigationCompleteEvent(callback, context) {
            return $dyn.shell.navigationCompleteEvent().subscribe(callback, context);
        }
        shell.subscribeToNavigationCompleteEvent = subscribeToNavigationCompleteEvent;
        function unsubscribeToNavigationCompleteEvent(id) {
            $dyn.shell.navigationCompleteEvent().unsubscribe(id);
        }
        shell.unsubscribeToNavigationCompleteEvent = unsubscribeToNavigationCompleteEvent;
        function navigateToForm(options) {
            // This function encapsulates navigation to a form and any related requirements
            // such as closing windows and raising completion or error events
            $dyn.shell.closeAllFormsBeforeNavigating(function () {
                $dyn.shell.createForm(options);
                $dyn.observe($dyn.async.pending, function (pending) {
                    if (pending === 0) {
                        $dyn.shell.navigationCompleteEvent().raise(options);
                        return false;
                    }
                });
            });
        }
        shell.navigateToForm = navigateToForm;
        /**
         * Provides the active form.
         * @description Note: This form could be a primary or dialog form type.
         */
        function getActiveForm() {
            return $dyn.shell.activeFormElement;
        }
        shell.getActiveForm = getActiveForm;
        function isCurrrentIndex(index) {
            return index === $dyn.shell._currentStackIndex;
        }
        shell.isCurrrentIndex = isCurrrentIndex;
        /**
         * Provides the visible primary form.
         * @description Note: It is not required to be the active form.
         * @returns The top primary form.
         */
        function getCurrentRootForm() {
            var targetElement;
            var stack = $dyn.shell.stack(); // Need to access stack() to ensure observability relationship created.
            if ($dyn.shell._currentStackIndex >= 0) {
                targetElement = stack[$dyn.shell._currentStackIndex];
            }
            if ($dyn.log.navigation && $dyn.shell._currentStackIndex >= 0 && !targetElement && !$dyn.shell.browserHistory.goingBack) {
                // Note, this returns undefined when the shell is initialized and when a form is closed from the middle of the stack.
                // Task 880464 : Error handling during navigation
                $dyn.log.navigation("Navigation: Target element not found in $dyn.shell.stack for _currentStackIndex of %s.", $dyn.shell._currentStackIndex);
            }
            return targetElement;
        }
        shell.getCurrentRootForm = getCurrentRootForm;
        function getPlaceholderForm() {
            if (!shell._placeholderForm) {
                var element = document.createElement("form");
                element.setAttribute("data-dyn-role", "Form");
                $dyn.dataBind(element);
                shell._placeholderForm = $dyn.context(element);
            }
            return shell._placeholderForm;
        }
        shell.getPlaceholderForm = getPlaceholderForm;
        function isCurrentFormDefaultForm() {
            return $dyn.shell.defaultForm.name
                && $dyn.context($dyn.shell.getCurrentRootForm())
                && $dyn.context($dyn.shell.getCurrentRootForm())._formName === $dyn.shell.defaultForm.name;
        }
        shell.isCurrentFormDefaultForm = isCurrentFormDefaultForm;
        /**
         * Provides the active dialog
         */
        function getCurrentDialog() {
            var targetElement;
            var dialogStackLength = $dyn.length(this.dialogStack);
            if ($dyn.shell.dialogStack()[dialogStackLength - 1]) {
                targetElement = this.dialogStack()[dialogStackLength - 1];
            }
            else if (this.getCurrentRootForm() && $dyn.context(this.getCurrentRootForm()).dialogStack()) {
                var rootFormDialogStackLength = $dyn.length($dyn.context(this.getCurrentRootForm()).dialogStack);
                targetElement = $dyn.context(this.getCurrentRootForm()).dialogStack()[rootFormDialogStackLength - 1];
            }
            return targetElement;
        }
        shell.getCurrentDialog = getCurrentDialog;
        function getFocusedControl() {
            var activeForm = $dyn.context($dyn.shell.getActiveForm());
            var focusedControl = null;
            if (activeForm) {
                focusedControl = $dyn.context(activeForm.GetFocusedControl());
            }
            return focusedControl;
        }
        shell.getFocusedControl = getFocusedControl;
        function deactivateElement(targetElement, options) {
            if (targetElement) {
                if (!options || !options.doNotHide) {
                    // Do not hide is typically set for dialogs being opened when a dialog is already open
                    if (targetElement.style) {
                        targetElement.style.display = "none";
                    }
                }
                var targetContext = $dyn.context(targetElement);
                if (targetContext) {
                    $dyn.log.navigation &&
                        $dyn.log.navigation("Navigation: Deactivating the %s/%s form (%s)", targetContext.Name ? targetContext.Name : "<unknown>", targetContext._formName ? targetContext._formName : "<unknown>", targetContext.Id);
                    // If we are deactivating a form with an active slider, we need to deactivate the slider.
                    var dialogElement = void 0;
                    var dialogContext = void 0;
                    for (var i = $dyn.length(targetContext.dialogStack) - 1; i >= 0; i--) {
                        dialogElement = targetContext.dialogStack()[i];
                        dialogElement.style.display = "none";
                        dialogContext = $dyn.context(dialogElement);
                        if (dialogContext && dialogContext.IsActive) {
                            dialogContext.IsActive(false);
                        }
                    }
                    // close any whatsnewDialogs for this form
                    $dyn.whatsNew.closeTipsForForm(targetContext._formName);
                    if (targetContext.IsActive) {
                        targetContext.IsActive(false);
                    }
                }
            }
        }
        shell.deactivateElement = deactivateElement;
        function tryActivateParentElement(context, options) {
            // Set the active element to the Flyout context Root instead of the asidePane.
            if (context.Root &&
                context.Root.element &&
                !$(context.Root.element)
                    .parents()
                    .hasClass("asidePane")) {
                $dyn.shell.activateElement(context.Root.element, options);
            }
            else {
                var targetForm = $dyn.shell.getCurrentRootForm();
                if (context.element) {
                    // Not all elements have Root set. In certain flyout scenarios we want the flyout parent to be activated instead of the
                    // current root form. One such scenario is a filter by grid flyout presented within a regular flyout. We want the host
                    // flyout to be activated in that case.
                    var $flyoutRoot = $dyn.flyout.flyoutManager.findFlyoutContainer(context.element);
                    if ($flyoutRoot.length === 1) {
                        var flyoutRootContext = $dyn.context($flyoutRoot[0]);
                        if (flyoutRootContext && flyoutRootContext.Root && flyoutRootContext.Root.element) {
                            targetForm = flyoutRootContext.Root.element;
                        }
                    }
                }
                $dyn.shell.activateElement(targetForm, options);
            }
        }
        shell.tryActivateParentElement = tryActivateParentElement;
        function activateElement(targetElement, options) {
            var targetContext = $dyn.context(targetElement);
            if (targetContext && targetContext.canActivate) {
                if (targetContext) {
                    $dyn.log.navigation &&
                        $dyn.log.navigation("Navigation: Activating the %s/%s form (%s)", targetContext.Name ? targetContext.Name : "<unknown>", targetContext._formName ? targetContext._formName : "<unknown>", targetContext.Id);
                }
                // Activate dialogs before activating the primary form, shell dialogs have first priority.
                // Exception: forceActivation flag, will skip this step.  MessagesBoxes and Popups are example consumers.
                if (!options || !options.forceActivation) {
                    $dyn.shell.trimDialogs(targetContext.dialogStack);
                    var dialogStackLength = $dyn.length(targetContext.dialogStack);
                    if (dialogStackLength > 0) {
                        // make sure the underlying form and any parent dialogs will be visible under the reactivating dialog.
                        targetElement.style.display = "";
                        for (var i = 0; i < dialogStackLength - 1; i++) {
                            targetContext.dialogStack()[i].style.display = "";
                        }
                        targetElement = targetContext.dialogStack()[dialogStackLength - 1];
                        targetContext = $dyn.context(targetElement);
                    }
                }
                // If the layout flag has not been set before calling this arrange,
                // explicitly set it so that elements queued for a reflow during the arrange will get reflowed.
                var layoutSet = $dyn.ui.layout();
                if ($dyn.value(targetContext.IsActive) === false) {
                    if (!layoutSet) {
                        $dyn.ui.layout(true);
                    }
                    targetContext.IsActive(true);
                }
                // The css class 'active-form' can get out of sync with IsActive property
                // and the IsActive change fires a layout for the form.
                // Right now we can have multiple IsActive=true but only one element with the css class 'active-form'
                var isFormActive = targetContext.isNavigationActiveForm && !targetContext.isNavigationActiveForm();
                if (isFormActive) {
                    $dyn.shell.setActiveForm(targetElement);
                }
                if ($dyn.restrictedNavigation || $dyn.flags.useDesignTimeView) {
                    // There is no user avatar when restrictedNavigation is true or designtime view is in use
                    $dyn.shell.formRenderingComplete(true);
                }
                else {
                    // Set the flag to true to indicate that form is rendered.
                    $.when($dyn.deferred.onTrue(function () {
                        return !!($dyn.value($dyn.user) || $dyn.value($dyn.clientInError));
                    })).done(function () {
                        $dyn.shell.formRenderingComplete(true);
                    });
                }
                // Trigger layout before calling takeNavigationFocus
                if (!layoutSet) {
                    $dyn.ui.layout(false);
                }
                var allowTakeNavigationFocus = !options || options.takeNavigationFocus === undefined || options.takeNavigationFocus;
                // Trigger takeNavigationFocus to restore setting focus to a control.
                if (isFormActive && targetContext.takeNavigationFocus && allowTakeNavigationFocus) {
                    // make sure the active control get focus
                    $dyn.log.focus && $dyn.log.focus("Focus: Shell->activateElement Id: %s calling takeNavigationFocus", targetContext.Id);
                    targetContext.takeNavigationFocus();
                }
                // if there is a lightbox we need to show it. Note that lightboxes are not the only thing that can be in the shell dialog stack.
                // Dialogs without a parent form (such as those navigated to using the navigation list) will also be in that stack
                if ($dyn.length($dyn.shell.dialogStack) > 0) {
                    var dialogStackLength = $dyn.length($dyn.shell.dialogStack);
                    var dialogElement = $dyn.shell.dialogStack()[dialogStackLength - 1];
                    var dialogContext = $dyn.context(dialogElement);
                    if (dialogContext.TypeName === "LightBox") {
                        dialogContext.IsActive(true);
                        $dyn.shell.setActiveForm(dialogElement);
                        if (dialogContext.takeNavigationFocus && allowTakeNavigationFocus) {
                            // make sure the active control get focus
                            $dyn.log.focus && $dyn.log.focus("Focus: Shell->activateElement shell dialog Id: %s calling takeNavigationFocus", dialogContext.Id);
                            dialogContext.takeNavigationFocus();
                        }
                    }
                }
                // Update the crumbs
                // Future work
                // For now, special case for the Dashboard
                if ($dyn.shell.isCurrentFormDefaultForm()) {
                    var navBar = $dyn.ui.getNavBar();
                    if (navBar && navBar.clearCrumb) {
                        navBar.clearCrumb();
                    }
                }
                else if (targetContext && targetContext.FormName) {
                    $dyn.DynReact.ModuleStore.updateFormCrumbs(targetContext.FormName);
                }
            }
            else {
                // Should this be a thrown error, or just logged ... Task 880464 : Error handling during navigation
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Element can not be activated.");
            }
        }
        shell.activateElement = activateElement;
        function resetShellOnNavigation() {
            // raise event for shell reset
            $(document.body).trigger("resetShellOnNavigation");
            $("body").trigger(jQuery.Event("click"));
        }
        shell.resetShellOnNavigation = resetShellOnNavigation;
        function getNavigationBar() {
            if ($dyn.shell._navBar === null) {
                $dyn.shell._navBar = document.getElementById($dyn.shell.NavBarDocumentId);
            }
            return $dyn.shell._navBar;
        }
        shell.getNavigationBar = getNavigationBar;
        function getUserSettingButton() {
            if ($dyn.shell._userSettingButton == null) {
                $dyn.shell._userSettingButton = document.getElementById($dyn.shell.UserDocumentId);
            }
            return $dyn.shell._userSettingButton;
        }
        shell.getUserSettingButton = getUserSettingButton;
        /** @internal */
        shell.stackContainerId = "PrimaryConductor";
        /**
         * Internal method for the shell to manage main content
         * @internal
         */
        function navigate(options) {
            if (!options) {
                return;
            }
            var host = options.host ? options.host : document.getElementById($dyn.shell.stackContainerId);
            if (!($dyn.shell.getCurrentRootForm() === options.targetElement)) {
                // What is this check for?  Unique IDs...
                $dyn.shell.deactivateElement($dyn.shell.getCurrentRootForm());
                host && host.appendChild(options.targetElement);
                // Pushing to the stack will trigger observers, which expect to use getPrimaryForm.  Need to set the stack pointer before pushing.
                if (options.typeName === "Dialog") {
                    $dyn.shell.dialogStack.push(options.targetElement);
                }
                else {
                    $dyn.shell._currentStackIndex = $dyn.length($dyn.shell.stack); // Length gives us the +1 for after we push to the stack
                    $dyn.shell.stack.push(options.targetElement);
                }
                $dyn.shell.activateElement(options.targetElement);
                $dyn.shell.browserHistory.createState(options.targetElement, options);
            }
            // we need to special case the placement for our filter/list buttons on all forms, need to see if they exist then set form left margin class
            var currentForm = $dyn.shell.getCurrentRootForm();
            if (currentForm && (currentForm.getElementsByClassName("button_showFilters")[0] || currentForm.getElementsByClassName("button_showList")[0])) {
                currentForm.classList.add("showGutterButtons");
            }
            // make sure the shell is reset
            $dyn.shell.resetShellOnNavigation();
        }
        shell.navigate = navigate;
        // expected use with forEach method of array of selected pivots on the form.
        // The function assumes that we are outside of "forward" navigation, so we will not add to the browser history.
        function selectTabs(pivotName, index, array) {
            var thisPivotItem = $dyn.ui.findControl(this[pivotName], $dyn.ui.RootType.form);
            if (thisPivotItem && thisPivotItem.Activate) {
                thisPivotItem.Activate();
            }
            else {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: unable to find pivot %s during back navigation.", pivotName);
            }
        }
        shell.selectTabs = selectTabs;
        function openWindow(options) {
            var newWindow;
            if ($dyn.uwa && $dyn.uwa.isUWA) {
                $dyn.uwa.openInExternalBrowser(options.url);
            }
            else {
                if (options.features) {
                    newWindow = window.open(options.url, options.target, options.features);
                }
                else {
                    newWindow = window.open(options.url, options.target);
                }
                if (!newWindow) {
                    // Popout failed to open. Probably due to a popout blocker
                    // Display a message to the user at this point.
                    $dyn.showMessageBox({
                        showOkButton: true,
                        Text: $dyn.format($dyn.label("Shell_PopupBlocked"), $dyn.value($dyn.shell.ProductName)),
                    });
                }
                return newWindow;
            }
        }
        shell.openWindow = openWindow;
        function navigateUrl(options) {
            if (!options) {
                return;
            }
            if (options.openInNewTab === undefined) {
                options.openInNewTab = true;
            }
            if (options.showExitWarning === undefined) {
                options.showExitWarning = true;
            }
            if (options.openInNewTab) {
                $dyn.shell.openWindow({ url: options.url, target: "_blank" });
            }
            else if (options.showExitWarning) {
                // open in the same tab, but show the exit warning
                // if a button click to trigger, it will temporarily turn off the $dyn.flags.confirmExit.
                // if previous condition is ConfirmExitFlag on, then we should turn it on again.
                if ($dyn.resetConfirmExitFlag) {
                    $dyn.flags.confirmExit = true;
                    $dyn.resetConfirmExitFlag = false;
                }
                window.location.href = options.url;
            }
            else {
                // open in the same tab, but without the exit warning
                // turn off the exit warning. If previous exit warning is on, set resetflag = true
                if ($dyn.flags.confirmExit) {
                    $dyn.resetConfirmExitFlag = true;
                }
                $dyn.flags.confirmExit = false;
                window.location.href = options.url;
            }
        }
        shell.navigateUrl = navigateUrl;
        shell.canGoBack = $dyn.computed(function () {
            var countHistoryItems = $dyn.length($dyn.shell.browserHistory.navigationHistory);
            return countHistoryItems > 1;
        });
        // used by handler for the previous view command on the form to initiate navigating back one step in the session history.
        // used by the escape key handler on controls.form
        function initiateBack() {
            var dialogElement = $dyn.shell.getCurrentDialog();
            if ($dyn.length($dyn.shell.dialogStack) > 0) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: initiateBack was called, but the shell took no action.  All open dialogs must be closed before going back");
                // throw error?  Shouldn't reach this point.  Task 880464 : Error handling during navigation
            }
            else if (dialogElement) {
                // We already checked for lightboxes in the shell.dialogStack so this must be a form dialog.
                $dyn.log.navigation && $dyn.log.navigation("Navigation: initiateBack was called while a slider was open.  Closing the slider.");
                $dyn.applyFunction($dyn.context(dialogElement).Close);
            }
            else if ($dyn.shell.canGoBack()) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: initiateBack was called, going back 1 entry in browser history.");
                $dyn.shell.browserHistory.backNavigationInitiatedByBrowser = false;
                history.back();
            }
            else {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: initiateBack was called when we have only 1 form in the navigation stack.");
                $dyn.shell.closeAllFormsBeforeNavigating(function () {
                    if ($dyn.restrictedNavigation && $dyn.popout && $dyn.serverForm) {
                        // If we are a popout, after closing forms, close the window.
                        // For the case of restrictedNavigation but not popout (meaning limitedNav is set instead), just drop through to goHome
                        $dyn.serverForm._windowManager.closePopoutWindow(false);
                    }
                    else {
                        // If there is nowhere to go, after closing the form go home.
                        $dyn.shell.goHome();
                    }
                });
            }
        }
        shell.initiateBack = initiateBack;
        /**
         * Removes client artifacts for a form.
         * @description Do not call directly for forms backed by a server form, this function does not inform the server of the close operation.
         * @private
         * @param options If not provided the current root form will be removed
         */
        function removePrimaryForm(options) {
            var index = -1;
            var targetElement;
            if (!options) {
                // assume we are closing the top form.
                index = $dyn.shell._currentStackIndex;
                targetElement = $dyn.shell.stack()[index];
            }
            else if (options.index >= 0) {
                index = options.index;
                targetElement = $dyn.shell.stack()[index];
            }
            else {
                targetElement = options.targetElement;
                index = $dyn.shell.stack().lastIndexOf(targetElement);
            }
            if (!targetElement) {
                $dyn.logError("Shell: Target element not found in $dyn.shell.stack, removePrimaryForm() tried to remove index %s.", index);
                $dyn.log.navigation && $dyn.log.navigation("Shell: Target element not found in $dyn.shell.stack, removePrimaryForm() tried to remove index %s.", index);
                // Task 880464 : Error handling during navigation
            }
            $dyn.log.navigation && $dyn.log.navigation("Navigation: Closing client form at stack position: ", index);
            if ($dyn.length($dyn.shell.dialogStack) || $dyn.length($dyn.context(targetElement).dialogStack)) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Root form was closed when a dialog was still open.");
            }
            $dyn.shell._removeForm(targetElement);
            $dyn.shell.stack.setAt(index, null);
            // further steps needed if we are removing the active form
            if (index === $dyn.shell._currentStackIndex) {
                // Remove extra navigation history entries to the active form if it has multiple views.
                $dyn.shell.browserHistory.removeExtraNavigationHistoryEntries(index);
                // Update the shell stack
                $dyn.shell.trimStack(index);
                // Figure out where to go next
                if ($dyn.length($dyn.shell.stack)) {
                    // If there is something left in the navigation stack, go back.
                    // If wait is false it will call complete, if wait is true, wait for the value to be false before calling complete
                    // $dyn.observe executes the function the first time when it is initiated
                    $dyn.observe($dyn.shell.browserHistory.waitForPopStateHandler, function (value) {
                        if (!$dyn.value(value)) {
                            $dyn.shell.browserHistory.completeBackNavigation();
                            return false;
                        }
                    });
                }
                else {
                    // If there is nothing left in the stack, decide where to go.
                    if ($dyn.shell.isExiting) {
                        // now that all forms are closed allow the user to exit.
                        history.back();
                    }
                    else {
                        if ($dyn.restrictedNavigation && !$dyn.shell.isClosingOpenForms && $dyn.serverForm && $dyn.serverForm._windowManager) {
                            // If we are a popout or limitedNav and there are no forms left, we should close the window.
                            $dyn.callFunction($dyn.serverForm._windowManager.closePopoutWindow, $dyn.serverForm._windowManager, true);
                        }
                        else {
                            $dyn.shell.restartNavigationStack();
                        }
                    }
                }
            }
        }
        shell.removePrimaryForm = removePrimaryForm;
        // Pop the last element from the primary stack if it is null and we have no navigation references to it.
        // We can safely remove elements if two conditions are met, otherwise we must leave a sparse array.
        // This is because the index pointer in the browser history must stay in sync with the shell stack.
        // It is the responsibility of the caller to further update _currentStackIndex and activate the correct form.
        function trimStack(index) {
            // Condition 1: only remove from the top of the stack
            // Condition 2: there are no further references in the browser history to that index position.
            // 1. is actually redundant, but faster to check than 2.
            if (index === $dyn.length($dyn.shell.stack) - 1 && ($dyn.shell.isClosingOpenForms || !$dyn.shell.browserHistory.checkForReferences(index))) {
                // TODO: if open forms is revisited, this will need review.
                // popping off the stack will trigger observers, which expect to use getPrimaryForm.  Need to set the stack pointer before popping.
                $dyn.shell._currentStackIndex = index - 1;
                $dyn.shell.stack.pop();
            }
        }
        shell.trimStack = trimStack;
        /**
         * Remove forms from the provided dialog stack while the top form is marked as willBeClosed.
         * @private
         * @param stack The dialog stack to be trimmed.
         */
        function trimDialogs(stack) {
            var dialogStackLength = $dyn.length(stack);
            while ((dialogStackLength > 0) && $dyn.context(stack()[dialogStackLength - 1]).willBeClosed) {
                // as the dialog was marked as closing, do not activate it;
                // instead, remove it from the back navigation and dialogStack
                var closingDialog = stack.pop();
                $dyn.shell._removeForm(closingDialog);
                dialogStackLength = $dyn.length(stack);
            }
        }
        shell.trimDialogs = trimDialogs;
        /**
         * Close the active dialog.
         * @returns true if the dialog is closed.
         */
        function dialogBack(options) {
            var navigationStack;
            var applicationModal = false;
            // Start by finding the stack that has the top most dialog in it.
            // Check for application modal dialogs first, then for form modal dialogs
            if ($dyn.length($dyn.shell.dialogStack)) {
                navigationStack = $dyn.shell.dialogStack;
                applicationModal = true;
            }
            else {
                var context_1 = $dyn.context($dyn.shell.getCurrentRootForm());
                if (context_1 == null) {
                    // No dialogs are open on the active form.
                    // Should this be a thrown error, or just logged ... Task 880464 : Error handling during navigation
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: dialogBack() was called but not dialogs were open on the shell or active form.");
                    return true;
                }
                if ($dyn.length(context_1.dialogStack) > 0) {
                    navigationStack = context_1.dialogStack;
                }
            }
            var dialogStackLength = $dyn.length(navigationStack);
            // Mark out-of-order close requests on the dialog stack to be handled later (The top dialog is not active || the form that requested the close is not the top dialog)
            if (!navigationStack || !navigationStack()[dialogStackLength - 1]) {
                // Should this be a thrown error, or just logged ... Task 880464 : Error handling during navigation
                $dyn.log.navigation && $dyn.log.navigation("Navigation: dialogBack() was called when no dialogs were in the dialogs stacks.");
                // No dialogs are open on the active form.
                return true;
            }
            else if (navigationStack()[dialogStackLength - 1].id !== $dyn.shell.getActiveForm().id
                || (options && options.element && options.element.id !== navigationStack()[dialogStackLength - 1].id)) {
                // Look through all the open dialogs to find the one that should be closed (currently the shell dialog stack and the active form dialog stack are checked)
                var matchingForm = void 0;
                var dialogContext = options && options.element ? $dyn.context(options.element) : undefined;
                if (dialogContext) {
                    matchingForm = $dyn.shell.findFormById($dyn.shell.dialogStack, dialogContext.Id);
                    if (!matchingForm && $dyn.context($dyn.shell.getCurrentRootForm())) {
                        matchingForm = $dyn.shell.findFormById($dyn.context($dyn.shell.getCurrentRootForm()).dialogStack, dialogContext.Id);
                    }
                }
                if (matchingForm) {
                    matchingForm.willBeClosed = true;
                }
                else {
                    // Should this be a thrown error, or just logged ... Task 880464 : Error handling during navigation
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: A close form request was received for a dialog that is not on the dialog stack.");
                }
                // The dialog being closed is not at the top of the stack
                // The top of the stack is often a message box that is opened *before* the dialog is now being closed.
                // This is done so that contextual information is still on the screen behind the message box.
                // The dialog is closing but is not closed yet
                return false;
            }
            // The dialog is at the top of the stack
            var current = navigationStack.pop();
            $dyn.shell._removeForm(current);
            $dyn.shell.trimDialogs(navigationStack);
            var newDialogStackLength = $dyn.length(navigationStack);
            if (!$dyn.shell.isClosingOpenForms) {
                if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                    // If there is an open flyout, restore focus to the flyout
                    var flyoutObject = $dyn.flyout.flyoutManager.getTopFlyout();
                    if (flyoutObject && flyoutObject.flyout) {
                        var flyout_1 = $dyn.value(flyoutObject.flyout);
                        if (flyout_1 && flyout_1.length) {
                            $dyn.shell.activateElement(flyout_1[0], { forceActivation: true });
                        }
                    }
                }
                else if ($dyn.length(navigationStack) > 0) {
                    $dyn.shell.activateElement(navigationStack()[newDialogStackLength - 1]);
                }
                else {
                    if (($dyn.shell._currentStackIndex === 0 && $dyn.length($dyn.shell.stack()) === 0) || $dyn.shell._currentStackIndex === -1) {
                        // Closing a slider or lightbox that was opened when we had no primary forms open
                        $dyn.shell.restartNavigationStack();
                    }
                    else if ($dyn.length($dyn.shell.stack()) > $dyn.shell._currentStackIndex) {
                        $dyn.shell.activateElement($dyn.shell.stack()[$dyn.shell._currentStackIndex]);
                    }
                    else {
                        $dyn.log.navigation &&
                            $dyn.log.navigation("Navigation: Error, _currentStackIndex of %s is >= than $dyn.shell.stack.length of %s.", $dyn.shell._currentStackIndex, $dyn.length($dyn.shell.stack()));
                        // throw error?  Task 880464 : Error handling during navigation
                    }
                }
            }
            // The dialog is successfully closed
            return true;
        }
        shell.dialogBack = dialogBack;
        /**
         * Private method for the shell to manage main content
         * @internal
         */
        function _removeForm(element) {
            // When a form is removed it is detached, deactivated, and unbound (if no override)
            if (element) {
                var context_2 = $dyn.context(element);
                if (context_2) {
                    context_2.IsActive(false);
                    if ($dyn.value(context_2.disposeOnClose)) {
                        // This typically done, disposeOnClose is rarely set to false
                        $dyn.unbind(element);
                    }
                }
                if (element.dynOptions) {
                    element.dynOptions = null;
                }
                if (element.dynResources) {
                    element.dynResources = null;
                }
                if (element.dynClose) {
                    element.dynClose = null;
                }
                $(element).remove();
            }
        }
        shell._removeForm = _removeForm;
        /**
         * Create and navigate to $dyn.shell.defaultForm.
         * @internal
         */
        function goHome() {
            var navBar = $dyn.ui.getNavBar();
            if (navBar && navBar.clearCrumb) {
                navBar.clearCrumb();
            }
            var options = $dyn.shell.defaultForm;
            options.targetElement = undefined;
            options.context = undefined;
            options.updateQuery = true;
            var menuItem = options.menuItem ? options.menuItem : "";
            $dyn.telemetry.addNavigationEvent("goHome", menuItem, []);
            $dyn.shell.createForm(options);
            $.when($dyn.deferred.onTrue(function () {
                return $dyn.value($dyn.async.pending) === 0;
            })).done(function () {
                if ($dyn.shell.getCurrentRootForm() !== undefined) {
                    $dyn.shell.defaultForm.name = $dyn.context($dyn.shell.getCurrentRootForm()).FormName;
                }
            });
        }
        shell.goHome = goHome;
        // Reset the navigation history and goHome so we don't leave the user with an empty screen
        function restartNavigationStack() {
            if (!$dyn.shell.isClosingOpenForms) {
                // Wait for all pending actions to complete. If we still don't have a
                // form when pending actions complete, then we can redirect to the dashboard.
                $.when($dyn.deferred.onTrue(function () {
                    return $dyn.value($dyn.async.pending) === 0;
                })).done(function () {
                    if (!($dyn.length($dyn.shell.stack) || $dyn.length($dyn.shell.dialogStack))) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: All open forms were closed, resetting navigation artifacts and then running $dyn.shell.goHome()");
                        $dyn.shell._resetNavigationStack();
                        $dyn.shell.goHome();
                    }
                });
            }
        }
        shell.restartNavigationStack = restartNavigationStack;
        function _resetNavigationStack() {
            $dyn.shell._currentStackIndex = -1;
            $dyn.shell.activeFormElement = null;
            $dyn.shell.stack.clear();
            $dyn.shell.dialogStack.clear();
            $dyn.shell.browserHistory.init();
        }
        shell._resetNavigationStack = _resetNavigationStack;
        /**
         * Cleans up all open forms in a current window. No server trips, only client objects are cleaned.
         * Callback is called after all forms are cleaned up.
         *
         * @param callback Function to be executed when all forms are successfully cleaned up
         */
        function cleanWindowFormsBeforeNavigating(callback) {
            if ($dyn.serverForm) {
                // tslint:disable-next-line:forin
                for (var root_id in $dyn.serverForm.interactionHandler.forms) {
                    $dyn.serverForm.interactionHandler.closeFormByRootId(root_id);
                }
                $dyn.serverForm.interactionHandler.forms = {};
                $dyn.serverForm.forceCloseAllPopouts();
            }
            if (callback) {
                $dyn.applyFunction(callback);
            }
        }
        shell.cleanWindowFormsBeforeNavigating = cleanWindowFormsBeforeNavigating;
        /**
         * Sequentially close all popout windows
         * If all popouts are successfully closed, close all forms in current window
         * Else, if any form fails to close, stop the sequence and do not close any of the forms in current window.
         *
         * @param callback Function to be executed if all forms are successfully closed
         * @param options Parameters for the form close operation
         */
        function closeAllFormsBeforeNavigating(callback, options) {
            var closeFormsInPopoutFailed = function () {
                $dyn.error({ Message: $dyn.label("Shell_AbortedNavigationPopout"), Label: "Shell_AbortedNavigationPopout" });
            };
            var closeFormsInThisWindowCallback = function () {
                $dyn.shell.closeWindowFormsBeforeNavigating(callback, undefined, options);
            };
            if ($dyn.serverForm) {
                $dyn.serverForm.closeAllPopouts(closeFormsInThisWindowCallback, closeFormsInPopoutFailed);
            }
            else {
                closeFormsInThisWindowCallback();
            }
        }
        shell.closeAllFormsBeforeNavigating = closeAllFormsBeforeNavigating;
        /**
         * Sequentially close all open forms in the current window, starting with the most recent.
         * If all open forms are successfully closed, execute the callback.
         * Else, if any form fails to close, stop the sequence and do not execute the callback.
         *
         * @param callback Function to be executed if all forms are successfully closed
         * @param errorCallback Function to be executed if an error happens during form close
         * @param options Parameters for the form close operation
         */
        function closeWindowFormsBeforeNavigating(callback, errorCallback, options) {
            if (callback === $dyn.shell.goHome && $dyn.shell.isCurrentFormDefaultForm()) {
                // Don't open a new form if the navigation request is to open the default Form and we are already there.
                $dyn.shell.isClosingOpenForms = false;
                $dyn.shell.closingAllCallback = undefined;
                $dyn.shell.closingErrorCallback = undefined;
                if ($dyn.ui.getNavBar()) {
                    $dyn.ui.getNavBar().clearCrumb();
                }
                if ($dyn.length($dyn.shell.stack) > 0) {
                    $dyn.shell.activateElement($dyn.value($dyn.shell.stack)[$dyn.length($dyn.shell.stack) - 1]);
                }
                $dyn.shell.refreshData(true);
            }
            else if ($dyn.shell.isClosingOpenForms && $dyn.shell.closingAllCallback === $dyn.shell.goHome && $dyn.length($dyn.shell.stack) === 1 && $dyn.shell.isCurrentFormDefaultForm()) {
                // After closing all other forms, if the form at the bottom of the stack is our destination, just refresh it.
                $dyn.shell.isClosingOpenForms = false;
                $dyn.shell.closingAllCallback = undefined;
                $dyn.shell.closingErrorCallback = undefined;
                if ($dyn.ui.getNavBar()) {
                    $dyn.ui.getNavBar().clearCrumb();
                }
                while ($dyn.length($dyn.shell.browserHistory.navigationHistory) > 1) {
                    $dyn.shell.browserHistory.navigationHistory.pop();
                }
                $.when($dyn.deferred.onTrue(function () {
                    return $dyn.value($dyn.async.pending) === 0 && !$dyn.value($dyn.shell.browserHistory.waitForPopStateHandler);
                })).done(function () {
                    // set a timeout to allow browser history calls to finish.
                    window.setTimeout(function () {
                        $dyn.shell.activateElement($dyn.value($dyn.shell.stack)[0]);
                        $dyn.shell.refreshData(false);
                        $dyn.shell.browserHistory.clearForward();
                    });
                });
            }
            else {
                if (!$dyn.shell.isClosingOpenForms) {
                    $dyn.shell.isClosingOpenForms = true;
                    if (typeof $dyn.getFunction(callback) === "function") {
                        $dyn.shell.closingAllCallback = callback;
                    }
                    else {
                        $dyn.logWarning("Shell:  closeWindowFormsBeforeNavigating should be called with a callback.");
                        $dyn.shell.closingAllCallback = $dyn.shell.goHome;
                    }
                    if (typeof errorCallback === "function") {
                        $dyn.shell.closingErrorCallback = errorCallback;
                    }
                    if (options && options.closeDashboard) {
                        $dyn.shell.closingAllCloseDashboard = true;
                    }
                    else {
                        $dyn.shell.closingAllCloseDashboard = false;
                    }
                    if (options && options.retainCrumb) {
                        $dyn.shell.closingAllRetainCrumb = true;
                    }
                    else {
                        $dyn.shell.closingAllRetainCrumb = false;
                    }
                    // Cache the value in case we close any forms that change the company.
                    if (options && options.destinationCompany) {
                        $dyn.shell.closingAllDestinationCompany = options.destinationCompany;
                    }
                    else {
                        $dyn.shell.closingAllDestinationCompany = $dyn.value($dyn.user().Company);
                    }
                }
                $.when($dyn.deferred.onTrue(function () {
                    return $dyn.value($dyn.async.pending) === 0;
                })).done(function () {
                    // check the stack for forms that haven't been closed.
                    $dyn.shell.closingAllIndex = $dyn.length($dyn.shell.stack) - 1;
                    while ($dyn.shell.closingAllIndex >= 0) {
                        if ($dyn.value($dyn.shell.stack)[$dyn.shell.closingAllIndex] && $dyn.value($dyn.shell.stack)[$dyn.shell.closingAllIndex].id) {
                            break;
                        }
                        $dyn.shell.closingAllIndex--;
                    }
                    if ($dyn.shell.closingAllIndex > 0 || ($dyn.shell.closingAllIndex === 0 && ($dyn.shell.closingAllCloseDashboard || !$dyn.shell.isCurrentFormDefaultForm()))) {
                        var thisForm_1 = $dyn.context($dyn.shell.stack()[$dyn.shell.closingAllIndex]);
                        $dyn.shell.closingAllIndex--;
                        if (thisForm_1) {
                            $dyn.async(function () {
                                $dyn.log.navigation && $dyn.log.navigation("Navigation: closeWindowFormsBeforeNavigating is calling form.Close for form: " + $dyn.value(thisForm_1.FormName));
                                $dyn.callFunction(thisForm_1.Close, undefined, { closeCallback: $dyn.shell.closeWindowFormsBeforeNavigating });
                            }, undefined, "Navigation: closeWindowFormsBeforeNavigating");
                        }
                        else {
                            $dyn.log.navigation && $dyn.log.navigation("Navigation: Error, closeWindowFormsBeforeNavigating could not find the form context.");
                            // Continue on to the previous form.
                            $dyn.shell.closeWindowFormsBeforeNavigating();
                        }
                    }
                    else {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: All open forms were closed, executing the callback");
                        $dyn.shell.isClosingOpenForms = false;
                        var thisClosingAllCallback_1 = $dyn.shell.closingAllCallback;
                        $dyn.shell.closingAllCallback = undefined;
                        $dyn.shell.closingErrorCallback = undefined;
                        if (!$dyn.shell.closingAllRetainCrumb && $dyn.ui.getNavBar() && $dyn.ui.getNavBar().clearCrumb) {
                            $dyn.ui.getNavBar().clearCrumb();
                        }
                        // purge our cached history, but leave the last one if we kept the defaultForm open.
                        while ($dyn.length($dyn.shell.browserHistory.navigationHistory) > $dyn.length($dyn.shell.stack)) {
                            $dyn.shell.browserHistory.navigationHistory.pop();
                        }
                        // set a timeout to allow browser history calls to finish.
                        window.setTimeout(function () {
                            $dyn.user().updateCompany($dyn.shell.closingAllDestinationCompany);
                            // Need to wait if a company change is required before opening the new form.
                            $.when($dyn.deferred.onTrue(function () {
                                return $dyn.value($dyn.async.pending) === 0 && !$dyn.value($dyn.shell.browserHistory.waitForPopStateHandler);
                            })).done(function () {
                                $dyn.shell.browserHistory.clearForward();
                                $dyn.applyFunction(thisClosingAllCallback_1);
                            });
                        });
                    }
                });
            }
        }
        shell.closeWindowFormsBeforeNavigating = closeWindowFormsBeforeNavigating;
        function refreshData(recordable) {
            var formContext = $dyn.context($dyn.shell.getActiveForm());
            if (formContext) {
                $dyn.callFunction(formContext.RefreshData, formContext, recordable);
            }
        }
        shell.refreshData = refreshData;
        function logOut() {
            $dyn.flags.confirmExit = false;
            $dyn.serverForm.endSession();
            window.location.href = "Logout";
        }
        shell.logOut = logOut;
        shell.preventFormAction = true;
        function formAction(event) {
            if ($dyn.shell.preventFormAction) {
                event.preventDefault();
            }
        }
        shell.formAction = formAction;
        function isActiveControl(controlClass) {
            var isActive = false;
            var activeForm = $dyn.context($dyn.shell.getActiveForm());
            if (activeForm && activeForm.isActiveControl) {
                isActive = activeForm.isActiveControl(controlClass.Name);
            }
            return isActive;
        }
        shell.isActiveControl = isActiveControl;
        function findFormById(stack, id) {
            var context;
            for (var i = $dyn.length(stack) - 1; i >= 0; i--) {
                context = $dyn.context($dyn.value(stack)[i]);
                if (context && context.Id === id) {
                    return context;
                }
            }
            return undefined;
        }
        shell.findFormById = findFormById;
        // Initialize session parameters from the URL query string
        function initializeUserSettingsFromURL() {
            var query = $dyn.util.location.query;
            var user = $dyn.user();
            $dyn.setObservableValue(user, "Company", query[$dyn.shell.QueryStringKeys.companyKey.toLowerCase()]);
            $dyn.setObservableValue(user, "Language", query[$dyn.shell.QueryStringKeys.languageKey.toLowerCase()]);
            // Partition is an AX specific user property
            $dyn.setObservableValue(user, "RequestPartition", query[$dyn.shell.QueryStringKeys.partitionKey.toLowerCase()]);
            var themeValue = query[$dyn.shell.QueryStringKeys.themeKey.toLowerCase()];
            $dyn.densityThemeManager._setCurrentTheme(themeValue);
            var densityValue = query[$dyn.shell.QueryStringKeys.densityKey.toLowerCase()];
            $dyn.densityThemeManager._setCurrentDensity(densityValue);
            if ($dyn.debug.vs === true) {
                $dyn.flags.fromVS = true;
                if ($dyn.debug.confirmExit === true) {
                    $dyn.flags.confirmExit = true;
                }
                $dyn.shell.hideSplash = true;
            }
            $dyn.observe($dyn.options(function () {
                return {
                    company: user.Company,
                    partition: user.RequestPartition,
                };
            }, user.Updating), $dyn.shell.updateURLFromUserSettings);
        }
        shell.initializeUserSettingsFromURL = initializeUserSettingsFromURL;
        // Initialize browser activity recovery parameters from the URL query string
        function initializeBrowserActivityFromURL() {
            var query = $dyn.util.location.query;
            var browserActivityKey = $dyn.shell.QueryStringKeys.browserActivityKey.toLowerCase();
            var expirationKey = $dyn.shell.QueryStringKeys.expirationKey.toLowerCase();
            var activityKey = $dyn.shell.QueryStringKeys.activityKey.toLowerCase();
            var browserActivityId = query[browserActivityKey];
            var expirationTimestamp = query[expirationKey];
            var now = Date.now();
            // Recover the browser activity parameters from the URL query string
            if (browserActivityId && expirationTimestamp && expirationTimestamp > now && $dyn.browserActivity) {
                var activityId = query[activityKey];
                var data = {
                    bid: browserActivityId,
                    expiration: expirationTimestamp,
                    aid: activityId,
                };
                $dyn.browserActivity.resetBrowserSessionActivity(now, data);
            }
            // Remove the browser activity recovery parameters from the query string and update the URL if necessary
            var shouldUpdateURL = browserActivityKey in query || expirationKey in query || activityKey in query;
            delete query[browserActivityKey];
            delete query[expirationKey];
            delete query[activityKey];
            if (shouldUpdateURL) {
                window.history.replaceState(window.history.state, null, $dyn.util.location.absoluteUrl());
            }
        }
        shell.initializeBrowserActivityFromURL = initializeBrowserActivityFromURL;
        // Added for enabling the task guide mode in the product
        // This will dictate to show/hide the getting started section in the dashboard.
        function isTrialMode() {
            var queryKeys = $dyn.util.parseQueryString(window.location.search);
            var mode = queryKeys.mode;
            if (mode === "trial") {
                return true;
            }
            else {
                return false;
            }
        }
        shell.isTrialMode = isTrialMode;
        function updateURLFromUserSettings(userSettings) {
            var urlbuilder = $.extend({}, $dyn.util.location);
            urlbuilder.query = $dyn.util.parseQueryString(window.location.search);
            var companyKey = $dyn.shell.QueryStringKeys.companyKey.toLowerCase();
            var partitionKey = $dyn.shell.QueryStringKeys.partitionKey.toLowerCase();
            var comp = false;
            // for company if the query string does not have the parm and we have userSettings data set it so
            // every session have the URL parm
            if ((urlbuilder.query[companyKey] === undefined || urlbuilder.query[companyKey] === "") && userSettings.company) {
                urlbuilder.query[companyKey] = userSettings.company;
                comp = true;
            }
            else {
                comp = hasURLParameterChanged(companyKey, userSettings.company);
            }
            var part = hasURLParameterChanged(partitionKey, userSettings.partition);
            if (comp || part) {
                var newUrl = $dyn.util.relativeUrl(urlbuilder);
                window.history.replaceState(window.history.state, null, newUrl);
                $(document).trigger("updateUtilLocationQuery");
            }
            function hasURLParameterChanged(key, value) {
                var userValue = value && value.toLowerCase ? value.toLowerCase() : value;
                if (urlbuilder.query[key] && urlbuilder.query[key].toLowerCase() !== userValue) {
                    urlbuilder.query[key] = userValue;
                    return true;
                }
                return false;
            }
        }
        shell.updateURLFromUserSettings = updateURLFromUserSettings;
        /**
         * Updates the internal representation of the URL query string and then updates the browser url accordingly.
         *
         * New keys are added with their value
         *
         * Existing keys have three cases:
         * - Unchanged if no key is provided
         * - Updated if a key/value pair is provided
         * - Deleted from the query string if the key is provided with undefined or null value.
         *
         * @param updatedParameters Object with key/value pairs to be updated
         */
        function _updateUrlParameters(updatedParameters) {
            if (updatedParameters) {
                var urlBuilder_1 = $.extend({}, $dyn.util.location);
                Object.keys(updatedParameters).forEach(function (key) {
                    var value = updatedParameters[key];
                    if (value === null || value === undefined) {
                        // We do want to allow "false" or false to be included as url parameters, but we won't support adding keys without values.
                        delete urlBuilder_1.query[key];
                    }
                    else {
                        urlBuilder_1.query[key] = value;
                    }
                });
                window.history.replaceState(window.history.state, null, $dyn.util.relativeUrl(urlBuilder_1));
                $(document).trigger("updateUtilLocationQuery");
            }
        }
        shell._updateUrlParameters = _updateUrlParameters;
        function setStartPage() {
            var user = $dyn.user();
            $dyn.shell.defaultForm = {
                menuItem: user.Startpage(),
                role: "Form",
                elementCreated: function (options) {
                    if ($dyn.serverForm) {
                        $dyn.serverForm.getForm(options);
                    }
                },
            };
            if (user.Startpage() && $dyn.shell.defaultForm.name === undefined) {
                $.when($dyn.deferred.onTrue(function () {
                    return $dyn.value($dyn.async.pending) === 0;
                })).done(function () {
                    if ($dyn.shell.getCurrentRootForm() !== undefined
                        && user.Startpage().toLowerCase() === $dyn.value($dyn.context($dyn.shell.getCurrentRootForm()).MenuItemName).toLowerCase()) {
                        $dyn.shell.defaultForm.name = $dyn.context($dyn.shell.getCurrentRootForm()).FormName;
                    }
                });
            }
        }
        shell.setStartPage = setStartPage;
        function getQueryStringForNewMenuItem(menuItem) {
            var urlbuilder = $.extend({}, $dyn.util.location);
            urlbuilder.query = $dyn.util.parseQueryString(window.location.search);
            var miString = menuItem;
            // Remove the default type if it is 'Display', this depends on the default method in $dyn.serverForm.interactionHandler.getForm
            if (miString) {
                var miFragments = miString.split(":");
                if (miFragments[0] === "Display") {
                    miString = miFragments[1];
                }
            }
            if (miString) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Updating the ?mi parameter to %s", miString);
                urlbuilder.query[$dyn.shell.QueryStringKeys.menuItem] = miString;
            }
            else {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: Clearing the ?mi parameter from the URL");
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.menuItem];
            }
            // clear the ?f= parameter, since we are either clearing the parameters to be on the dashboard or adding a mi=
            if (urlbuilder.query[$dyn.shell.QueryStringKeys.formName]) {
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.formName.toLowerCase()];
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.formName.toUpperCase()];
            }
            if (urlbuilder.query[$dyn.shell.QueryStringKeys.pageType.toLowerCase()]) {
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.pageType];
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.pageType.toLowerCase()];
                delete urlbuilder.query[$dyn.shell.QueryStringKeys.pageType.toUpperCase()];
            }
            return $dyn.util.relativeUrl(urlbuilder);
        }
        shell.getQueryStringForNewMenuItem = getQueryStringForNewMenuItem;
        // Handles any shell based responsive changes in javascript
        function _viewportChangeHandler(event, currentViewportWidthSize) {
            if (currentViewportWidthSize) {
                var viewPortSizeSmall = currentViewportWidthSize < $dyn.shell.CurrentViewportSizes.viewportWidth + $dyn.shell.CurrentViewportSizes.gutterWidth;
                if (!$dyn.shell.isPhone && !$dyn.shell._isPhoneSize && viewPortSizeSmall) {
                    $(document.body).addClass("xsmallView");
                    $dyn.shell._isPhoneSize = true; // this is used mainly for this code
                    $dyn.shell.isPhone = true; // this enables js based code to run as phone selected
                    $dyn.shell.isNavigationPanePinned(true);
                    $dyn.shell._renderNavigationPane();
                    $(window).trigger("resize");
                }
                else {
                    if ($dyn.shell._isPhoneSize && !viewPortSizeSmall) {
                        $(document.body).removeClass("xsmallView");
                        $dyn.shell._isPhoneSize = false;
                        $dyn.shell.isPhone = false;
                        $dyn.shell.isNavigationPanePinned(false);
                        $dyn.shell._renderNavigationPane();
                        $(window).trigger("resize");
                    }
                }
            }
        }
        shell._viewportChangeHandler = _viewportChangeHandler;
        // Allow setting some styles dependent upon the device
        // Detect properties that would not change during a session
        function setDeviceMode() {
            // Detect if running iOs "app" mode, Safari runs in full screen mode
            if (window.navigator.standalone) {
                $(document.body).addClass("iOSApp");
            }
            // Checking specifically for Edge due to limited webkit scroll bar support in Edge
            // Edge backlog item: https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9081910-add-support-for-scrollbar-styling
            if (window.navigator.userAgent.indexOf("Edge") !== -1) {
                $dyn.shell.isEdge = true;
                $(document.body).addClass("MSEdge");
            }
            var mobileExp = new RegExp("Android|webOS|iPhone|" + "BlackBerry|Windows Phone|" + "Opera Mini|IEMobile|Mobile", "i");
            if ($dyn.util.location.query.usePhoneLayout !== "false" && ($dyn.util.location.query.usePhoneLayout === "true" || mobileExp.test(navigator.userAgent))) {
                // in case this is a tablet that is large enough dont set class to phone
                if (window.innerWidth <= $dyn.shell.NavBarSizes.smallNavBarSize) {
                    $(document.body).addClass("phoneDevice");
                    $dyn.shell.isPhone = true;
                }
            }
            else {
                $(document.body).removeClass("phoneDevice");
                $dyn.shell.isPhone = false;
            }
            // set event listners for responsive
            $dyn.shell._viewportChangeHandler(null, $dyn.shell.CurrentShellViewPortWidthSize);
            $dyn.shell.viewportBindingHandler = $dyn.bindingHandlers.ShellViewportWidthSize();
            $dyn.shell.viewportBindingHandler.apply($dyn.shell._viewportChangeHandler, $dyn.shell);
        }
        shell.setDeviceMode = setDeviceMode;
        shell.primaryForm = $dyn.computed(function () {
            return $dyn.context($dyn.shell.getCurrentRootForm());
        });
        shell.primaryFormCaption = $dyn.observable("");
        function setDocumentTitle(newCaption) {
            if (newCaption !== $dyn.shell.ProductShortName()) {
                document.title = $dyn.format($dyn.label("Shell_BrowserTitleFormat"), newCaption, $dyn.shell.ProductShortName());
            }
            else {
                document.title = $dyn.shell.ProductShortName();
            }
            $dyn.log.navigation && $dyn.log.navigation("Navigation: Browser title changed to: %s", document.title);
        }
        shell.setDocumentTitle = setDocumentTitle;
    })(shell = $dyn.shell || ($dyn.shell = {}));
    $(window).on("PreviousView", function (evt) {
        // We handle this command client side so prevent the default action
        // and initiate the action.
        evt.preventDefault();
        $dyn.callWhenNotBusy($dyn.shell.initiateBack);
    });
    $(window).on("Refresh", function (evt) {
        // We handle this command client side so prevent the default action
        // and initiate the action.
        evt.preventDefault();
        $dyn.shell.refreshData(true);
    });
    $(window).on("DeleteRecord", function (evt) {
        $dyn.shell.callCommandButtonFunction($dyn.shell.CalledCommandButtonFunction.DeleteRecord, evt);
    });
    $(window).on("New", function (evt) {
        $dyn.shell.callCommandButtonFunction($dyn.shell.CalledCommandButtonFunction.New, evt);
    });
    $dyn.resetConfirmExitFlag = false;
    // Sniffing for IE is bad practice, we should use feature detection.
    // But we are looking for a feature that is present, but implementation is "wrong".
    // Temporary measure to turn off the warning for IE10 which throws onbeforeunload events in
    // situations where it shouldn't.  IE11 does not include 'MSIE' in the userAgent string.
    // Improve during Deliverable 828459: Intelligent refresh/exit warning
    if (navigator.userAgent.indexOf("MSIE") === -1) {
        window.addEventListener("beforeunload", function (event) {
            if ($dyn.flags.confirmExit) {
                if ($dyn.flags.fromVS) {
                    return $dyn.label("Shell_LeavingDebugIE");
                }
                else {
                    return $dyn.label("Shell_LeavingSession");
                }
            }
            if ($dyn.resetConfirmExitFlag) {
                window.setTimeout(function () {
                    $dyn.flags.confirmExit = true;
                    $dyn.resetConfirmExitFlag = false;
                }, 500);
            }
        });
    }
})($dyn || ($dyn = {}));

//# sourceMappingURL=Shell.js.map
